module.exports = {
  "action": {
    "search": "Search",
    "search1": "Display",
    "creat": "New ",
    "creat1": "Create ",
    "creat2": "New",
    "renew": "Update",
    "renew1": "Refresh",
    "recheck": "Recheck ",
    "import": "Import ",
    "Importing": "Importing...",
    "export": "Export ",
    "input": "Please input ",
    "improve": "Please complete ",
    "select": "Please choose",
    "select1": "Select",
    "write": "Input ",
    "whether": "Whether ",
    "edit": "Edit ",
    "change": "Modify ",
    "copy": "Copy ",
    "modifiable": "Modifiable ",
    "delete": "Delete",
    "delete1": "Clear",
    "regain": "Confirm recover? ",
    "stopusing": "Disable? ",
    "Enable": "Enable ",
    "Deactivate": "Deactive ",
    "expand": "Expand ",
    "fold": "Fold",
    "photograph": "Photo ",
    "login": "Login",
    "login1": "User login",
    "logout": "Logout ",
    "contract": "Contact the customer service",
    "wxScan": "Please scan the QR code with Wechat",
    "modifyPwd": "Change password",
    "confirm": "Confirm ",
    "confirm1": "Confirm ",
    "convertTo": "Convert",
    "return": "Return ",
    "return1": "Return",
    "return2": "Returned",
    "noreturn": "Unreturned",
    "noreturn1": "Incompleted return",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "use": "Use ",
    "add": "Add ",
    "add1": "Add ",
    "upload": "Upload ",
    "save": "Save ",
    "save1": "Draft ",
    "cancel": "Cancel ",
    "close": "Close ",
    "scan": "Scan ",
    "scan1": "Scan ",
    "operate": "Operate ",
    "synchronous": "Synchronize ",
    "yes": "Yes ",
    "no": "No ",
    "have": "have ",
    "nothing": "None ",
    "deactivate": "Deactivate ",
    "restore": "Restore ",
    "statistics": " Statistics ",
    "gather": "Gather ",
    "applyfor": "Apply ",
    "newapplyfor": "New ",
    "Notappliedfor": "Not applied for",
    "print": " Print ",
    "need": "Need ",
    "notNeed": "No need",
    "automatic": "Automatic ",
    "delayed": "Delayed ",
    "describe": "Describe ",
    "association": " Relevant ",
    "independence": " Irrelevant ",
    "remind": "Remind ",
    "handle": "Handle ",
    "way": " Method ",
    "calculate": "Calculate ",
    "binding": " Bind",
    "unbind": " Unbind ",
    "binding1": "Bound",
    "count": "Count ",
    "Bold": "Bold ",
    "disassemble": "Disassemble ",
    "examine": "Examine ",
    "record": "Input ",
    "record1": "Record ",
    "registration": "Register ",
    "Collection": "Recycling ",
    "sterilization": "Sterilization ",
    "disinfect": "Disinfect ",
    "recycle": "Return",
    "recycle1": "Returnable ",
    "Unrecycled": "Unreturned ",
    "package": "Packing",
    "package1": "Inspection&packing ",
    "package2": "Assemble ",
    "packagetwo": "Packing ",
    "package3": "Packed ",
    "Tbpackaged": "To be packed",
    "Secondinspection": "Reinspection",
    "Unpacked": "Unpacked ",
    "clean": "Cleaning ",
    "CleaningMachine": "WD",
    "Sterilizer": "Sterilizer ",
    "cleanquality": "Cleaning & Inspection ",
    "biological": "Biological monitoring ",
    "check": "Sorting",
    "out": "Delivery",
    "receive": "Receiving ",
    "Returnpackage": "Returning sets",
    "borrow": "Borrowing sets",
    "Backwash": "Back washing",
    "Delivery": "Delivery ",
    "Back": "Back",
    "urgent": "Urgent ",
    "infect": "Infect ",
    "supply": "Supply ",
    "patch": "Replenish ",
    "more": "More ",
    "complete": "Complete ",
    "success": "Succeed ",
    "fail": "Fail",
    "hand": "Manual ",
    "shield": "Shield",
    "maintenance": "Maintain",
    "Oneclick": "Oneclick",
    "obtain": "Obtain",
    "default": "Default",
    "display": "Display ",
    "Hidden": "Hide",
    "Hidden1": "Hidden",
    "Unhidden": "Unhidden",
    "repeatable": "Duplicate ",
    "Norepeatable": "Unduplicated ",
    "caption": "Note",
    "fit": "Settings",
    "manage": "Manage",
    "Handover": "Handover",
    "Patchwork": " Reprint ",
    "searchfor": "Search",
    "Centralized": "Centralized",
    "action": "Action ",
    "reset": "Reset ",
    "take": "Take "
  },
  "object": {
    "name": "Name ",
    "name1": "Name ",
    "name2": "Category ",
    "userName": "User name",
    "people": "Employee",
    "user": "User",
    "jobNumber": "Employ ID",
    "code": "Code ",
    "code1": "Code ",
    "code2": "Code ",
    "Totalcode": "Bacth Code",
    "pinyin": "Short name",
    "instrument": "Instruments ",
    "instrumentset": "Instrument sets ",
    "set": "Sets ",
    "information": "Information",
    "Implants": "Implant ",
    "unImplants": "Non-implant ",
    "hospital": "Hospital",
    "In": "Inside the hospital",
    "Outside": "Outside the hospital",
    "center": "Reprocessing unit",
    "center1": "Campus",
    "cssd": " CSSD ",
    "department": "Department ",
    "DepartmentGroup": "Department group",
    "supplier": "Supplier ",
    "container": "Basket ",
    "container1": "Tray ",
    "disposables": "Consumables",
    "Thispackage": "This set",
    "article": "Utensil",
    "type": "Type ",
    "page": "Page",
    "list": "Checklist",
    "table": "Table",
    "log": "Log",
    "annex": "Attachment",
    "detail": "Details ",
    "detail1": "Detail section",
    "longTerm": "Longterm loan",
    "shortTerm": "Shortterm loan",
    "group": " Group ",
    "password": "Password",
    "tel": "Tel.",
    "email": "Email",
    "address": "Address",
    "brand": "Brand",
    "unitPrice": "Unit price",
    "number": "Times",
    "number1": "Number",
    "number2": "Number of people",
    "pieces": "Pieces",
    "remarks": "Remarks",
    "weight": "Weight",
    "specifications": "Specification ",
    "model": "Model ",
    "g": "g",
    "image": "Image",
    "image1": "Image",
    "date": "Date",
    "time": "Time",
    "content": "Content",
    "file": "File ",
    "base": "Base quantity",
    "base1": "Base",
    "No": "None",
    "data": "Data",
    "whole": "All ",
    "all": "All ",
    "state": "Status ",
    "class": "Category",
    "inventory": " Inventory ",
    "location": "Location",
    "company": "Company ",
    "tag": " Label",
    "tag1": "Label ID",
    "trussUp": " Bunding ",
    "day": "Day",
    "day1": "Number of days",
    "individual": "EA",
    "validity": "Validity",
    "validity1": "Expire date",
    "warning": "Warning",
    "collocation": "Assemble ",
    "collocation1": "Grouping",
    "processe": "Routing",
    "property": "Property ",
    "sort": "Sort",
    "batch": "Batch ",
    "batch1": "Batch ",
    "document": "Document",
    "support": "Technical support",
    "ade": "Adverse event",
    "ade1": "Adverse event registration",
    "problem": "Problem ",
    "material": "Materials",
    "template": "Template",
    "cost": "Cost",
    "cost1": "Cost",
    "sum": " Amount ",
    "total": "Total",
    "total1": "Total",
    "sumtotal": "Total",
    "Thirdpartysystem": "3rd party system ",
    "note": "Note ",
    "other": "Others ",
    "level": "Level ",
    "demand": "Demand ",
    "tower": "Operation ",
    "units": "Operation serial No.",
    "Station": "OR table ID",
    "Filteritems": "Filter ",
    "Potnumber": "Device batch ",
    "Pot": "Device ID ",
    "circulatingnurse": "Runner",
    "scrubnurse": "Scrub Nrs",
    "reason": "Reason ",
    "post": "Position ",
    "education": "Education certification ",
    "title": "Title ",
    "gender": "Gender",
    "gender1": "Gender",
    "equipment": "Equipment ",
    "produce": "Manufacturer ",
    "produceTwo": "Manufacturer ",
    "delivery": "Deliveryman ",
    "deliverytime": "Delivery time ",
    "contactinformation": "Contact info. ",
    "patient": "Patient ",
    "outpatientservice": "Outpatient ",
    "moniker": "Name ",
    "male": "Male ",
    "female": "Female ",
    "Bednumber": "Bed ID ",
    "age": "Age ",
    "ward": "Ward ",
    "Chiefsurgeon": "Chief surgeon ",
    "operation": "Surgery ",
    "Proposedimplementation": "Proposal ",
    "Powertools": "Power tool ",
    "tool": "Tool ",
    "steelplate": "Steel plate ",
    "screw": "Screw ",
    "fullscreen": "full screen",
    "exit": "Exit ",
    "udi": " UDI ",
    "rfid": "RFID",
    "duration": "Duration ",
    "language": "Language setting",
    "chinese": "Chinese",
    "english": "English",
    "triditionalCN": "Traditional Chinese",
    "thai": "Thai",
    "loading": "Loading",
    "dictionaryName": "Dictionary Name",
    "dictionaryType": "Dictionary Type",
    "dataLabel": "Data Label",
    "dataKeyValue": "Data Key",
    "displaySorting": "Sorting",
    "divtLable": "Dictionary Label"
  },
  "describe": {
    "basic": "Basic ",
    "please": "Please ",
    "wait": "Later ",
    "foreign": "External ",
    "daixiao": "Subctract ",
    "dressing": "Surgical dressing ",
    "or": "or ",
    "and": "and ",
    "do": "do ",
    "Cannotbe": "cannot be ",
    "use": "use ",
    "stop": "stop ",
    "selected": "Selected ",
    "belongTo": "BelongTo ",
    "affiliation": "affiliation ",
    "standard": "standard ",
    "maximum": "maximum ",
    "regular": "regular ",
    "special": "special ",
    "prevail": "prevail ",
    "multiple": "Multiple ",
    "settlement": "Settlement ",
    "front": "front ",
    "after": "back ",
    "difference": "difference ",
    "excessive": "excessive ",
    "lack": "lack ",
    "must": "must ",
    "greaterthan": "Greater than ",
    "lessthan": "Less than ",
    "empty": "empty ",
    "correct": "correct ",
    "nothave": "none ",
    "right": "normal ",
    "saveas": "Save as ",
    "amountto": "Total ",
    "choose": "Return by set name ",
    "ordinary": "regular ",
    "documentation": "archieve ",
    "unmatched": "Unmatched ",
    "daily": " Daily "
  },
  "prompt": {
    "notnull": "Null is not allowed",
    "clickimg": "Click for details",
    "Existingproblems": "Scanning failed, please check your keyboard input mode or caps lock.",
    "Existed": "This set exists in the returning list already",
    "Unchecked": "Default as today without tick",
    "Unchecked1": "The linen sets has been issued already, countinue?",
    "notprint": "Printing cannot be triggered by PDA",
    "ShowOnly": "New records only",
    "error": "Error obtaining cached data",
    "delete": "Confirm to delete?",
    "convert": "Confirm to convert it into consumables?",
    "enter": "Hit Enter to submit",
    "saveduplicate": "Duplicated UDI exist, please check again!",
    "msg": "UDI exceeds the digits limitation, countinue?",
    "msg1": "-1 default value,none automatic delivery",
    "msg2": "0 delivery automaticaly and immediately",
    "msg3": ">0 delivery automaticaly and postpone for (unit:minute)",
    "msg4": "Sterilization validity setting relies on packing material, sterile method, season",
    "msg5": "Add notes for relevant settings, the reasons must be given if modification is necessary",
    "msg6": "Set settlment mode with relevant notes?",
    "msg7": "This set exists in the checklist already, please don't add it again'",
    "msg8": "This set hasn't been created in the system, do you want to create it?",
    "msg9": "Please input correct QTY of returned sets",
    "msg10": "QTY must greater than 0",
    "msg11": "Please scan the correct code",
    "msg12": "Please scan the basket code",
    "msg13": "Please select the sets to be pre-treated",
    "msg14": "Please select the instrument sets to be classified",
    "msg15": "Please select the sets to be withdrawn",
    "msg16": "Keep at least one data of basket",
    "msg17": "Please scan the pre-processor",
    "msg18": "This personnel code does not exist",
    "msg19": "Select the sets",
    "msg20": "Confirm to delete?",
    "msg21": "Please choose a supplemental reason!",
    "msg22": "This basket is not in the list",
    "msg23": "Scanning or selecting a cleaning program",
    "msg24": "Some sets do not support the current cleaning method, click to continue",
    "msg25": "Some sets do not support the current cleaning method, please adjust the cleaning method or select other sets",
    "msg26": "Please select the cleaning method",
    "msg27": "Please scan the WD program code",
    "msg28": "Please select the person who will start the cleaning and the cleaning program",
    "msg29": "Please scan or select WD",
    "msg30": "Please scan or select a cleaning program",
    "msg31": "Re-cleaning succeed",
    "msg32": "Operating success",
    "msg33": "Cleaning succeed",
    "msg34": "Amended cleaning time is earlier than return time of current set",
    "msg35": "confirm to continue",
    "msg36": "selected basket",
    "msg37": "The equipment is unregistered, please complete then continue",
    "msg38": "Cleanliness of the external surfaces of the cleaning equipment",
    "msg39": "Cleaning equipment display screen",
    "msg40": "Cleaning equipment printing paper",
    "msg41": "The door adhasive tape of cleaning equipment clean or not",
    "msg42": "Water and electrical fault or not",
    "msg43": "The pipes of the cleaning equipment are smooth",
    "msg44": "Whether the amount of enzyme oil is sufficient",
    "msg45": "Purified water conductivity (≤15us/cm2)",
    "msg46": "Cleaning equipment cabin clean or not",
    "msg47": "Cleaning equipment filter is clean",
    "msg48": "Whether the spray arm can rotate freely",
    "msg49": "Whether the spray arm nozzle is blocked",
    "msg50": "Cleaning equipment cleaning racks are clean",
    "msg51": "Please complete the form",
    "msg52": "Registration completed",
    "msg53": "Please scan the sets to be unloaded",
    "msg54": "Please select sterilizer and sterilizer rack",
    "msg55": "Please scan the sterilzing operator",
    "msg56": "The sterilizer has not been tested for leakage, continue or not?",
    "msg57": "This person is not a qualified sterilizing operator",
    "msg58": "Please select a sterilizer and program",
    "msg59": "The equipment is programmed to do biomonitoring everyday, whether to continue",
    "msg60": "The equipment is programmed to do biomonitoring for the first time everyday, whether to continue",
    "msg61": "The sterilizer has not been leak tested and cannot continue operation",
    "msg62": "The sterilizer has not been tested for BD qualification and cannot continue operation",
    "msg63": "This sterilizer has not been tested by BD. Still continue operation?",
    "msg64": "Please scan the sterilizer code",
    "msg65": "Please select the operator to start sterilization and sterilization procedure",
    "msg66": "Please select the sterilizer",
    "msg67": "Please select the sets to be sterilized",
    "msg68": "The selected sets are not available until sterilization time",
    "msg69": "Please fill in the reason for deletion",
    "msg70": "Please scan the sterilization rack",
    "msg71": "Please select a sterilizer first",
    "msg72": "Please select the sets to be identified",
    "msg73": "Please mark sets that require biological monitoring before starting sterilization",
    "msg74": "Please select a biomonitoring cause",
    "msg75": "There are sets that are treated differently and cannot start sterilizing",
    "msg76": "There are sets that are treated differently, still continue?",
    "msg77": "Please confirm if unload",
    "msg78": "Please scan the sets code",
    "msg79": "Confirm to delete?",
    "msg80": "file has been  successfully uploaded",
    "msg81": "Sterilization equipment external surface clean or not",
    "msg82": "Sterilization equipment cabin clean or not",
    "msg83": "Sterilizing equipment door adhasive tape clean or not",
    "msg84": "Sterilization equipment display screen",
    "msg85": "Sterilization equipment printing paper",
    "msg86": "The safety valve is in the calibration period",
    "msg87": "The pressure gauge is in calibration period",
    "msg88": "Please select the cause of failure",
    "msg89": "Please select a check method",
    "msg90": "No cleaning record found",
    "msg91": "No corresponding cleaning record was found",
    "msg92": "Upload picture successfully",
    "msg93": "Delete picture successfully",
    "msg94": "Do you want to end this cleaning batch?",
    "msg95": "Cleaning finished",
    "msg96": "It has not been cleaned and cannot be qualified",
    "msg97": "Scan clean and QC personnel",
    "msg98": "Cleaning and inspection succeed",
    "msg99": "Please select the sets to be qualified after cleaning",
    "msga1": "Withdraw to pending classification",
    "msga2": "Reasons for unqualified cleaning",
    "msga3": "Please select a reason",
    "msga4": "Statistics of sterilization quality spot check results",
    "msga5": "Quality monitoring of sterilized sets",
    "msga6": "Click image to enlarge",
    "msga7": "Abnormal biological culture tube",
    "msga8": "Please scan the second QC",
    "msga9": "Please scan the biological QC",
    "msga10": "please scan the inspector",
    "msga11": "Whether the surface of the set is damp",
    "msga12": "Whether the surface of the set has water mist or beads",
    "msga13": "Device cleanliness",
    "msga14": "Are you sure to end sterilization?",
    "msga15": "Please upload qualified inspection image",
    "msga16": "Sterilizing inspection passed",
    "msga17": "Scan biological inspector",
    "msga18": "Scan biological inspector and choose the reason",
    "msga19": "Scan biological inspector",
    "msge20": "Inspector cannot be the same person",
    "msga21": "Biological monitoring passed",
    "msga22": "Unqualified sterilization reason",
    "msga23": "Are sure to realse inadvance?",
    "msga24": "Input set code",
    "msga25": "Seach completed",
    "msga26": "Input correct set code",
    "msga27": "Input set code",
    "msga28": "Please select the layer",
    "msga29": "Please select the location",
    "msga30": "Please select a placement method",
    "msga31": "Please select the spot check results",
    "msga32": "Withdraw to sterilization. Do you confirm?",
    "msga33": "Advance release details",
    "msga34": "Scan sterilizing inspector",
    "msga35": "Please scan the operator",
    "msga36": "Statistics of sterilization quality spot check results",
    "msga37": "The list has been updated, please refresh it",
    "msga38": "Please select a destination department",
    "msga39": "Invalid sets to be delivered",
    "msga40": "Delivery completed",
    "msga41": "Please choose the item to be printed",
    "msga42": "Total quantity scanned by me",
    "msga43": "Input and hit Enter to replace item code scanning",
    "msga44": "Display urgent instrument sets",
    "msga45": "Display delivery record",
    "msga46": "Cancel delivery massively",
    "msga47": "Print scheduled delivery",
    "msga48": "This query has too much sets to display in a table, do you want to proceed?",
    "msga49": "Are you sure to delete the sets?",
    "msga50": "It's not in current delivery plan",
    "msga51": "Insert CA card to identify the approver",
    "msga52": "Please select the Certificate",
    "msga53": "Cancelled delivery",
    "msga54": "Please select an automatic Delivery plan",
    "msga55": "Insufficient stock",
    "msga56": "No urgent instrument sets exists in current list",
    "msga57": "No delivery plan could be cancelled",
    "msga58": "Delivery plan will be cancelled on ticked items which do not have set code, do you want to continue",
    "msga59": "You have urgent sets to be deliveryed!",
    "msga60": "Please scan deliverman",
    "msga61": "Please input or scan sender",
    "msga62": "Precise search",
    "msga63": "All loaners",
    "msga64": "Processing record of expired sets",
    "msga65": "Unqualified record",
    "msga66": "CSSD instrument sets quantity",
    "msga67": "Record unqualified delivery log",
    "msga68": "Clearance of expired sets",
    "msga69": "Department Return",
    "msga70": "This set exists already ",
    "msga71": "Desination department should be OR, delivery is not allowed",
    "msga72": "Please select a problem category",
    "msga73": "Input set code then hit Enter",
    "msga74": "Return & delivery comparison",
    "msga75": "Instrument set summary",
    "msga76": "Please input the recipient!",
    "msga77": "All items in this batch will be received",
    "msga78": "Scanned sets will be received",
    "msga79": "Input receiver",
    "msga80": "No available sets to be received",
    "mage81": "Unrecognized ID",
    "mage82": "This set hasn't been scanned",
    "mage83": "The current list cannot be blank",
    "msga84": "Please input set code or delivery ID before Entering",
    "msga85": "The recipient cannot be blank",
    "msga86": "Duplicate sets have been filtered out",
    "msga87": "Select withdrawal reason",
    "msga88": "Please select the reason for return",
    "msga89": "Please select the returned instrument set",
    "msga90": "Select an OR to be transferred",
    "msga91": "Please select one of the following departments to save, cancel will be",
    "msga92": "save",
    "msga93": "The registrant cannot be blank",
    "msga94": "The patient ID cannot be blank",
    "msga95": "The operating time cannot be blank",
    "msga96": "Allocate time",
    "msga97": "The patient's name cannot be blank",
    "msga98": "This set is being processed and cannot be reused",
    "msga99": "This set is being processed. Do you want to record and overwrite it?",
    "msgb1": "This instrument set has been recorded for other patient. Do you want to overwrite it?",
    "msgb2": "The surgery time has been adjusted to current time",
    "msgb3": "Please scan or input",
    "msgb4": "Please complete all mandatory fields",
    "msgb5": "Select a department before saving",
    "msgb6": "The patient of loaner instrument are inconsistant. Please confirm",
    "msgb7": "The patient of loaner instrument are inconsistant.",
    "msgb8": "Failed to record. Steriling time is behind surgery time",
    "msgb9": "Please select an operating room",
    "msgb10": "Transferred successfully",
    "msgb11": "Return successfully",
    "msgb12": "Select sets to be returned",
    "msgb13": "Are you sure to save it?",
    "msgb14": "Application is forbidden",
    "msgb15": "Keep applying agaisnt the selected reprocessing unit",
    "msgb16": "No replicatable instrument set",
    "msgb17": "Are you sure to cancel it?",
    "msgb18": "Selected CSSD is not the default one, do you want to replace it?",
    "msgb19": "This set exists in the list already",
    "msgb20": "The cart ID was not found",
    "msgb21": "Current list will be overwritten. Are you sure to continue?",
    "msgb22": "No available set in the template",
    "msgb23": "Do you need to merge duplicated items in current list?",
    "msgb24": "This set cannot be applied or has been applied already",
    "msgb25": "The system will send all applications to",
    "msgb26": "Do you need to merge duplicated items in current list?",
    "msgb27": "Applicants cannot be blank",
    "msgb28": "The application list cannot be blank",
    "msgb29": "The batch ID cannot be blank",
    "msgb30": "Select the sets to submit",
    "msgb31": "The application will be sent to relevant CSSD according to default settings. Do you want to continue?",
    "msgb32": "Insert CA card to identify the approver",
    "msgb33": "Complete the configuration of application printing first (Dictionary 248)",
    "msgb34": "Please select the urgent sets",
    "msgb35": "Please select an instrument set",
    "msgb36": "Please select the instrument sets to be deleted",
    "msgb37": "Are you sure to delete it?",
    "msgb38": "Borrowing records of department",
    "msgb39": "Used instrument sets record",
    "msgb40": "Select sets to be added",
    "msgb41": "No available item to be added",
    "msgb42": "Delivery request records",
    "msgb43": "Quantity inconsistent between application and delivery",
    "msgb44": "Do you need to merge duplicated items in current list?",
    "msgb45": "Are you sure to cancel it?",
    "msgb46": "Do you want to unbinding all sets linked with this patient?",
    "msgb47": "Quality issue log",
    "msgb48": "Unqualified cleaning",
    "msgb49": "Instrument integrality unqualified",
    "msgb55": "This set cannot be registered, because it has no instruments.",
    "msgb58": "Record unqualified delivery sets",
    "msgb60": "Please select equipment first.",
    "msgb61": "Please select Sterilization date first.",
    "successfullyAdded": "successfully added",
    "isSureToReturn": "Whether to withdraw to the previous step",
    "prompt": "This set is a non-tray label set which could be returned directly",
    "promptone": "The QTY of sets greater than",
    "prompttwo": "Sorting validation?",
    "promptthree": "Please choose the instrument sets with validation completed status",
    "prompt1": "Scanning failed, please check your keyboard input mode or caps lock.",
    "prompt2": "Failed to get sets information",
    "prompt3": "Please scan the UDI of the intrument or record the issue",
    "prompt4": "No returning information could be found, please try to scan other sets",
    "prompt5": "Undefinted set code",
    "prompt6": "Please tick relevant item first",
    "prompt7": "Please choose the sets to be returned",
    "prompt8": "The same name or specification exisits already",
    "prompt9": "All sets have been added, add more?",
    "prompt10": "The supplier is not in valid period",
    "error1": "Please select the supplier first",
    "error2": "Please configure the dictionary #372, otherwise the name of loaner cannot be displayed",
    "error3": "Please input the Set name",
    "error4": "Please input the correct QTY",
    "error5": "This set is not allowed to be packed",
    "deleted": "Delete successfully",
    "deactivated": "Deactivate successfully",
    "Import": "Successfully imported",
    "deactivat": "Confirm deactivate",
    "required": "Please fill in the required items",
    "permissions": "Select permissions",
    "Successfullymodified": "Successfully modified",
    "Successfullyadded": "Successfully added",
    "Operationsuccessful": "Operation successful",
    "Pleashospitalarea": "Please fill in the name of the hospital campus",
    "switchdevice": "Switch to instrument",
    "Successfullydevice": "Successfully switch to instrument",
    "Successfullyconsumables": "Successfully switch to consumables",
    "devicename": "Please input the instrument name",
    "duplicated": "Specifications and models cannot be repeated",
    "UDIinformation": "Please complete the UDI information",
    "greaterthan": "The number of devices must be more than 0",
    "packagename": "Please enter the set code first",
    "enterconsumables": "Please input consumables",
    "basicunit": "Please fill in the basic units",
    "programname": "Please fill in the program name",
    "Onlydefault": "Only one default program can be set",
    "informationfirst": "Please save the basic information first",
    "Successfullysaved": "Successfully saved",
    "Errorlabel": "Parsing the label content failed",
    "Contentempty": "The content is empty",
    "conversionerror": "Conversion error",
    "Pleasehospitaldepartment": "Please select hospital department",
    "addconsumptionpackage": "Please add inbound sets",
    "Addedsuccessfully": "Added successfully",
    "selecthospitalfirst": "Please select a campus first",
    "Norecyclableitems": "No returnable sets",
    "packagenormal": "This set is normal",
    "notapplied": "This set is not applied by department",
    "entercode": "Please enter a correct code",
    "selectbatch": "Please select a batch code ",
    "Inventorycompleted": "Inventory sorting completed",
    "Allcleared": "All records are cleared",
    "updatesuccess": "Updated successfully",
    "Registrationsuccessful": "Registration successfully",
    "recycleditemsempty": "Returning list is empty",
    "selectdepartment": "Please select department",
    "Pleaseadd": "Please add text",
    "Pleaseenter": "Please enter searching info",
    "Pleaseimage": "Please select image",
    "Nocamera": "The camera permission is not enabled or the browser version is incompatible",
    "takephotofirst": "Take a photo first",
    "selectfile": "Please select a file",
    "supportedtypes": "Please choose a file for upload, and below types are supported",
    "handoversupplyroom": "Please choose a CSSD to handover",
    "continueprinting": "The label has been printed, do you want to reprint it",
    "Pleasereplacement": "Select a reason for reprinting",
    "GeneratingQRcode": "Generating QR code",
    "Personnelduplicated": "Repeated operator is not allowed",
    "Pleasepotnumber": "Please fill in the sterilizer ID and batch ID",
    "Pleasepackagecode": "Input set code",
    "Pleaseselectdata": "Please select data",
    "rollback": "Are you sure to Withdraw it?",
    "Fallbacksuccessful": "Withdarw successfully",
    "Packageonly": "The same set can only be added once",
    "cacheablepackages": "No available set",
    "Pleasenumber": "Please select the label ID",
    "Pleasepackagingperson": "Please scan the packer",
    "Pleasereviewer": "Please scan the approver",
    "recoverysuccessful": "Recover successfully",
    "Personnelnotexist": "Account doesn't exist",
    "Pleasewait": "This instrument set can not be assembled, please wait",
    "Queryinformationframe": "Display the information and quantity of returned sets within the time range",
    "Queryinformationframe1": "Display the total quantity of returned sets by department within the time range",
    "Queryinformationframe2": "Display the information of WD running and sets processing within the time range",
    "Queryinformationframe3": "Display the information of sterilizer running and instrument set processing within the time range",
    "Queryinformationframe4": "Display the information and quantity of delivered instrument set within the time range",
    "Queryinformationframe5": "Display the total quantity of delivered instrument set by department within the time range",
    "Queryinformationframe6": "Monthly CSSD full cycle report by packing category by department",
    "Queryinformationframe7": "Yearly CSSD full cycle quantity and amount by department",
    "NumberExceed": "Quantitative restrictions",
    "packagereturn": "This set has been received. Do you want to withdraw it?",
    "secondIssueRightMsg1": "Scanned quantity does not reach the standard, possible omission. Do you want to continue?",
    "secondIssueRightMsg2": "The actual return quantity has not been reached, please check and try again",
    "secondIssueRightMsg3": "The quantity of delivery applications has not been reached, please check and try again",
    "secondIssueRightMsg4": "The quantity of packing batch has not been reached, please check the code and try again",
    "secondIssueRightMsg5": "Please select the sterilizer and date, then select the device batch"
  },
  "common": {
    "drag": "Drag file ",
    "download": "Download template",
    "full": "Full ",
    "lifetime": "Useful time",
    "action": "Action ",
    "list": "List ",
    "longTerm": "LongTerm ",
    "shortTerm": "ShortTerm ",
    "loangear": "Loaner",
    "disable": "Disable ",
    "enable": "Enable ",
    "baseOn": "Base on ",
    "applicationform": "Delivery application form ",
    "bundle": "Bundle ",
    "postponed": "Postponed ",
    "expirydate": "Expiry date ",
    "accounting": " Accounting ",
    "detail": "Details ",
    "countable": "Countable ",
    "section": "Section ",
    "include": "Include ",
    "before": "Before ",
    "after": "After",
    "employee": "Employee ",
    "sterilizer": "Sterilizer ",
    "ID": "ID ",
    "startdate": "Startdate ",
    "enddate": "Enddate ",
    "form": "Form ",
    "cache": "Cache ",
    "completed": " Completed ",
    "approver": "Approver ",
    "limmit": "Limit to ",
    "empty": "Clear",
    "if": "If ",
    "to": "To ",
    "ItemSummary": "Summary ",
    "selected": "Selected ",
    "Later": "Later ",
    "retrace": "Track",
    "procedure": "Procedure ",
    "result": "Result ",
    "Qualityinspector": "Quality inspector",
    "Secondqualityinspector": "Second quality inspector",
    "Accuratesearch": "Accurate search",
    "Pipelinenode": "Pipeline node",
    "Earlyrelease": "Advance release",
    "Selfuse": "Self use",
    "expire": "Expire",
    "location": "Location ",
    "washer": "WD",
    "program": "Program",
    "msg": "Please select the set that needs to be handed over",
    "msg1": "No printable data available",
    "msg2": "There are",
    "msg3": "expired sets in the sterile warehouse. Do you want to handle it immediately?",
    "msg4": "Please select the sets to be exported",
    "msg5": "Please select the items to be delivered",
    "msg6": "Query the processing process information of the sets within the intersection of the process time range",
    "msg7": "Please complete the information",
    "msg8": "Please select an existing set",
    "msg9": "There are no printable sets",
    "msg10": "You have equipment that has not been scanned. Do you want to continue?",
    "msg11": "Are you sure to clear it?"
  },
  "recycle": {
    "input": "Input ",
    "id": "ID ",
    "current": "Sorting",
    "statisList": "New instrument set statistic",
    "approved": "Approved ",
    "Returnpackage": "Returning sets",
    "loan": "Loaner",
    "daixiao": "Subctract ",
    "rec": "Returning",
    "applyVariance": "Application variance ",
    "infect": "Infection ",
    "urgent": "Urg. ",
    "level": "Level",
    "small_infect": "Inf. ",
    "summary": "Summary ",
    "from": "From ",
    "to": "To ",
    "quantity": "Quantity ",
    "recycled": "Returned",
    "borrowed": "Borrowing sets",
    "info": "Info.",
    "srg": "Srg.",
    "right": "Normal ",
    "inventory": "Inv.",
    "before": "before ",
    "after": "after ",
    "qty": "Qty. ",
    "process": "Process ",
    "operator": "Sorting operator ",
    "used": "Used "
  },
  "empty": {
    "moniker": "Name is required",
    "account": "Account is required",
    "password": "Password is required",
    "jobNumber": "Employee number is required",
    "department": "Department name is  required",
    "scopework": "Scope of work is required",
    "post": "Position is required",
    "types": "Types is required",
    "Courtyard": "Campus is required",
    "DepartmentGroup": "Department Group required",
    "center": "Reprocessing unit cannot be blank",
    "head": "Manager name is required",
    "number": "Account name is  required",
    "Device": "Instruments name cannot be blank",
    "Standard": "Standard name is required",
    "consumable": "Consumables name is required",
    "packageempty": "Set name is required",
    "returntimeempty": "Return time cannot be blank",
    "Recyclerempty": "Recycler cannot be blank",
    "Countingempty": "Sorting operator cannot be blank",
    "Manufacturerempty": "Manufacturer cannot be blank",
    "Supplierempty": "Supplier cannot be blank",
    "surgicadepartmentempty": "Surgical department is mandatory",
    "deliverempty": "Deliveryman is required",
    "Wardempty": "Ward is required",
    "replacementpersonempty": "Reprinting user can't be blank",
    "Sterilizerempty": "The sterilizing operator can not be blank",
    "packagingpersonempty": "The packer or assembler can not be blank",
    "Reviewerblank": "The approver cannot be blank",
    "cannotbeempty": "The packing material, sterilization method and validity period are mandatory",
    "departmentamountexportbeempty": "Department amount export time cannot be blank",
    "questiontypeempty": "Problem category cannot be blank",
    "Partcannotempty": "The position field cannot be blank"
  },
  "all": {
    "account": "Login account",
    "nodata": "No data",
    "personnel": "Employee Management",
    "Pinformation": "Employee information",
    "authority": "Access",
    "PersonalData": "Personal information",
    "certificate": "Certification",
    "Userlogin": "User information login",
    "scopework": "Work area",
    "Accountstatus": "Account status",
    "Endoscopic": "Endoscope ID",
    "role": "Role",
    "Menupermissions": "Menu permissions",
    "Buttonpermissions": "Button permissions",
    "Setavatar": "Set profile photo",
    "Basicinformation": "Basic information",
    "IDcard": "ID card",
    "nation": "Nationality",
    "Politicaloutlook": "Political status",
    "datebirth": "Date of birth",
    "Hobbies": "Hobbies",
    "WorkInformation": "Work Information",
    "position": "Position",
    "Nurselevel": "Nurse level",
    "entrytime": "Join date",
    "Timeresignation": "Resign Date",
    "mobilephone": "Mobile phone",
    "Homephone": "Home phone",
    "emergencycontact": "Emergency contact",
    "Emergencycall": "Emergency call",
    "email": "E-mail",
    "address": "Address",
    "filename": "File name",
    "blank": "Blank",
    "AddCenter": "Add reprocessing unit",
    "AddCampus": "Add Campus",
    "Synchronizedata": "Synchronize data",
    "Newgroup": "New department group",
    "Parentdepartment": "Upper-level department",
    "head": "Ower",
    "Expiration": "Sterilization storage expiration hours",
    "floor": "Building floor",
    "Unrestricted": "Unrestricted application",
    "registeruse": "Patient REG",
    "Blockexpiredpackages": "Hide expired sets",
    "HISDepartment": "HIS department",
    "HIScode": "HIS department code",
    "MaterialDepartment": "Storage system's department",
    "Materialcode": "Storage system department code",
    "DistributionPlan": "Delivery plan",
    "packagingbatch": "by packing batch ID",
    "distributionapplication": "Delivery by application form",
    "vehicle": "vehicle",
    "zhanghao": "account",
    "departmentmanagement": "department management",
    "Newdepartment": "New department",
    "EditingDepartment": "Edit Department",
    "Editdepartmentgroup": "Edit department group",
    "ConsumableManagement": "Consumables Management",
    "Allconsumables": "All Consumables",
    "DeviceManagement": "Instrument mangement",
    "fullname": "Fullname",
    "Devicebound": "Bounded instrument",
    "Packagingmethod": "Packing method",
    "Handlingmethod": "Sterilize method",
    "InventoryLocation": "Inventory Location",
    "Importcardinality": "Import base quantity",
    "ExportManifest": "Export Manifest",
    "Exportengravingpackage": "Export sets",
    "PageEditing": "Page Editing",
    "Devicepackagemanagement": "Instrument set management",
    "Inventorypackagestatistics": "Inventory statistics",
    "Isdevice": "If loaner",
    "corporatename": "Company name",
    "FixedDetails": "Fixed details",
    "Centralizednot": "Collective purchase",
    "Specialitems": "Special sets",
    "labelprinting": "Label printing",
    "Bundledprinting": "Bundled printing",
    "distributiondelay": "Delay delivery",
    "distri": "Based on delivery request",
    "Numberimplants": "Numbe rimplants",
    "Automaticallyperiod": "Correlate validity period",
    "Sterilizationvalidity": "Sterilization validity",
    "Disinfectionvalidity": "Disinfection validity",
    "Multiplesterilization": "Multiple sterilization",
    "cleaningmethod": "Cleaning method",
    "Sterilizationfee": "Sterilization fee",
    "Otherfee": "Other fee",
    "Cleaningfee": "Cleaning fee",
    "packagingfee": "Packing fee",
    "Distributionfee": "Delivery fee",
    "costamount": "Cost",
    "settlement": "Settlement amount",
    "newapplyfor": "New instrument fee",
    "AlertInventory": "Safety stock",
    "Numberdevices": "Number devices",
    "Numberconsumables": "Number consumables",
    "Numbercomponents": "Number components",
    "Locationencoding": "Location Code",
    "PropertyOwnership": "Property Ownership",
    "Costaccounting": "Costing type",
    "foreignpackage": "Loaner set category name",
    "Packagingprecautions": "Packing precautions",
    "Recyclingprecautions": "Returning precautions",
    "Cleaningprecautions": "Cleaning precautions",
    "Sterilizationprecautions": "Sterilization precautions",
    "Distributionprecautions": "Delivery precautions",
    "Packageengravingcode": "Tray label",
    "Creationtime": "Creation time",
    "Automaticupdate": "Automatically update",
    "Beforedisassembly": "Before disassembly",
    "Afterdisassembly": "After disassembly",
    "otherImplants": "Other Implants",
    "nootherImplants": "No other implants",
    "Details": "Fixed instrument details",
    "DeviceDetails": "Instrument Details",
    "ConsumableDetails": "Consumable Details",
    "Recycler": "Recycler",
    "PackagingSpecifications": "Packing specifications",
    "ExternalDeviceType": "Loaner Type",
    "TotalEquipmentPackage": "Total instrument set",
    "ItemsToBeClassified": "Sets to be classified",
    "BatchDeletion": "Batch Deletion",
    "BatchSupplementaryRecording": "Batch Supplementary Recording",
    "HandoverOfItems": "Sets handover",
    "BatchReturn": "Batch withdraw",
    "BasketCode": "Basket Code",
    "BatchSelection": "Batch Selection",
    "CourtyardHandover": "Handover between Campus",
    "Retreat": "Retreat",
    "ThereAreDeviceIssues": "Instrument issues",
    "SupplementaryRecording": "Supplementary Recording",
    "return3": "Withdrawal",
    "BatchPreprocessing": "Batch Preprocessing",
    "CleaningPreTreatmentPersonnel": "Cleaning Pretreatment Personnel",
    "ScanPersonnelCode": "ScanPersonnelCode",
    "Preprocessing": "Pre-processing",
    "DateFiltering": "Date Filtering",
    "DevicePackageName": "Set name",
    "Preprocessor": "Preprocessor",
    "TotalNumberOfItems": "Total sets",
    "Confirm": "Confirm",
    "FinishedSortingItems": "Sorted sets",
    "PreprocessingMethod": "Pre-processing Method",
    "ShortTermRentalOfForeignEquipment": "ShortTerm Loaner",
    "LongTermRentalOfExternalEquipment": "LongTermLoaner",
    "number": "Code",
    "Distributors": "Distributors",
    "Numberalerts": "Number alerts",
    "Basicunit": "Basic unit",
    "Units": "Unit conversion",
    "equipmentmanagement": "Equipment management",
    "price": "Price",
    "Life": "Useful time",
    "Sterilizationmethod": "Sterilization method",
    "Biologicaltime": "Biological inspection time",
    "contacts": "Contacts",
    "Telephone": "Telephone",
    "mobile": "mobile",
    "Firstusetime": "First use time",
    "Equipmentperson": "Equipment owner",
    "Departmentperson": "Department owner",
    "Specificationmodel": "Specification",
    "Qualityequipmenttype": "Quality equipment type",
    "Qualitysterilizationtype": "Quality sterilization type",
    "operatingcost": "Operating cost",
    "yuan": "$",
    "zeroclearing": "Reset batch ID daily",
    "prohibit": "Inconsistant sterilizing methods are prohibited",
    "Biologicalrequired": "Biological required for each batch",
    "Runprinting": "Run printing",
    "Endcalibration": "End calibration",
    "duration": "duration",
    "BD": "BD",
    "leakhunting": "Leaking-test ",
    "Emptyoperation": "Running empty",
    "Sideinspectiontime": "Leaking-test inspection time",
    "Defaultbiological": "Default biological",
    "Biologicalfrequency": "Biological frequency",
    "shelvingdata": "Force empty running and keep the data records",
    "first": "First",
    "everytime": "Everytime",
    "ReasonForSupplementaryRecording": "Reason for adding missed items",
    "ItemsToBeCleanedAndDisinfected": "Sets to be cleaned & disinfected",
    "BlueBasketName": "Basket Name",
    "stepByStepCleaning": "Manual cleaning",
    "integratedMachineCleaning": "Machine cleaning",
    "utensils": "Utensils",
    "cleaningMachineOperationStatus": "WD Status",
    "equipmentRegistrationRecords": "Equipment registration records",
    "itemName": "Sets name",
    "reCleaning": "Re-cleaning",
    "startCleaning": "Start cleaning",
    "disinfectionMethod": "Disinfection Method",
    "dryingMethod": "Drying method",
    "cleaningPersonnel": "Cleaner",
    "pleaseScanTheCleaner": "Please Scan a cleaner",
    "pleaseScanTheCleaningRack": "Please Scan a cleaning rack",
    "cleaningRack": "Cleaning rack",
    "cleaningProgram": "Cleaning program",
    "whetherToManuallyFillThePot": "Fill batch ID manually",
    "cleaningPotTimes": "Cleaning batch ID",
    "Loadingequipment": "Loading equipment",
    "Loadingtoolmanagement": "Loading tool management",
    "Warehouse": "Warehouse",
    "Batchprint": "Batch print",
    "repeatScan": "Duplicate Scanning",
    "tagname": "Lable name",
    "test": "Test",
    "prompt": "Prompt",
    "goRegister": "Register",
    "registrationOfCleaningEquipment": "Registration of cleaning equipment",
    "sterilizationEquipmentName1": "Sterilization equipment name1",
    "clean1": "Clean1",
    "noClean1": "Not cleaning",
    "abnormal": "Abnormal",
    "adequate": "Adequate",
    "insufficient": "Insufficicient",
    "fault": "Fault",
    "noFaults": "No faults",
    "unobstructed": "Unobstructed",
    "notUnobstructed": "Obstructed",
    "PHValue": "PH value",
    "enzymeAdditionAmount": "Enzyme dosage (ml)",
    "addLubricatingOil": "Add lubricating oil (ml)",
    "purifiedWaterPressure": "Purified water pressure",
    "compressedAir": "Compressed air",
    "salt": "salt",
    "can": "can",
    "cannot": "cannot",
    "block": "block",
    "noBlocking": "Non-blocking",
    "Preview": "Preview",
    "Totalpackages": "Total sets",
    "equipmentMaintenanceRecords": "Equipment maintenance records",
    "registrationTime": "Registration time",
    "registrationArea": "Record area",
    "deviceName": "Equipment name",
    "itemsToBeSterilized": "Sets to be sterilized",
    "addCurrentSterilizer": "Add into Current Sterilizer",
    "packagingDate": "Packing date",
    "sterilizationDate": "Sterilizing Date",
    "packageCode": "Set code",
    "registrationOfUnqualifiedPackaging": "Record unqualified packing",
    "registrationOfDeviceIssues": "Record issues",
    "sterilizationAndShelving": "Sterilization and shelving",
    "selectSterilizerAndSterilizationRack": "Select a sterilizer & rack",
    "sterilizerStatus": "Sterilizer status",
    "overallCodeListing": "Batch ID putaway",
    "totalCodeRemoval": "Batch ID picking",
    "biologicalMonitoringTime": "Biological Monitoring Time",
    "biologicalMonitoringReasons": "Biological Monitoring Reasons",
    "currentSterilizer": "Current sterilizer",
    "currentSterilizationRack": "Current sterilizing rack",
    "loaded": "Loaded",
    "packages": "piece sets",
    "departmentName": "Department name",
    "groupName": "Group Name",
    "preservationOfBiologicalMonitoringMarkers": "Save Biological Monitoring result",
    "startSterilization": "Start sterilizing",
    "inputCorrection": "Correction",
    "importOtherSterilizers": "Import into other sterilizer",
    "abnormalDeviceIssues": "Device abnormal issues",
    "packetCount": "sets quantity",
    "sterilizationRack": "sterilizing rack",
    "pleaseScanTheSterilizationRack": "Please scan a sterilizing rack",
    "sterilizationProcedure": "Sterilizing program",
    "currentlyNoProgram": "No program",
    "sterilizationPotNumber": "Load ID",
    "sign": "Sign",
    "testPackageCode": "Test set code",
    "reasonForDeletion": "Reason of deletion",
    "uploadAttachments": "Attachment upload",
    "Packagestatistics": "Total sets",
    "Recyclingrecords": "Returning approval records",
    "ReturnRecord": "Returned records",
    "Outsourcingpackage": "Inbound sets",
    "Allinstrumentpacks": "All instrument sets",
    "Usingunrecycled": "Using unreturned instruments",
    "Pleasecode": "Scan user ID",
    "Receiver": "Receiver",
    "Printdocuments": "Print returning documents",
    "Urgentlevel": "Urgent level",
    "Infectiontype": "Infection type",
    "Unreturnedquantity": "Unreturned quantity",
    "Supplementaryaddition": "Replenish new",
    "Registrationissues": "Record issues",
    "usageinformation": "Usage information",
    "Completeinventory": "Sorting completed",
    "clearall": "Clear all",
    "Excesspieces": "Excesspieces",
    "Lackquantity": "Lack quantity",
    "Returntime": "Return time",
    "Returnquantity": "Return quantity",
    "borrowedpackages": "Borrowed sets QTY",
    "Distributiontime": "Delivery time",
    "Issuedby": "Deliveryman",
    "recipient": "Recipient",
    "Returnregistration": "Return REG",
    "Returntime1": "Return time",
    "Returnquantity1": "Return quantity",
    "Proxyreception": "Receive inbound sets",
    "packaging": "Packing materials",
    "Addrecyclinglist": "Add returning list",
    "Manualrecycling": "Return manually",
    "Recyclingtemplates": "Returning templates",
    "Blockdepartments": "Blockdepartments",
    "RecyclingDepartment": "Returning department",
    "Binddepartments": "Binddepartments",
    "Basicmaintenance": "Basicmaintenance",
    "warn": "Warning",
    "DateTime": "Date&time",
    "Auditcode": "Approval ID",
    "operationroom": "Operation room",
    "Recyclingstatus": "Returning status",
    "hiddenstate": "Hidden state",
    "Packagingstatus": "Packing status",
    "Applicationdepartment": "Request department",
    "time": "Request time",
    "ApplicationNotes": "Request notes",
    "Quantity": "Quantity applied",
    "Recycledquantity": "Returned quantity",
    "Totaldepartmentapplications": "Total QTY of applications",
    "Recyclingtime": "Return time",
    "Demandtime": "Demand time",
    "Oneclickpackaging": "One click packing",
    "Dressingbag": "Linen sets",
    "registrant": "Registrant",
    "singlePot": "Individual batch",
    "pleaseSelectAPackage": "Please select a set",
    "sterilizationEquipmentRegistration": "Sterilization equipment registration",
    "sterilizationEquipment": "Sterilization equipment",
    "faulty": "Faulty",
    "pressureReducingValve": "Relief valve",
    "innerChamberPressure": "Inner chamber pressure(0)",
    "interlayerPressure": "Interlayer pressure(-0.1)",
    "tapWater": "Water(0.15-0.3MPa)",
    "compressedAir1": "Compressed air(0.4-0.7MPa)",
    "exhaustPort": "Exhaust port",
    "cabinetDoor": "Cabinet door",
    "wordsize": "Size",
    "Rowheight": "Row height",
    "Bold": "Bold",
    "alignment": "Alignment",
    "theleft": "Left",
    "Center": "Center",
    "theright": "Right",
    "Inversecolor": "Inverse color",
    "remove": "Remove",
    "Labelsize": "Label size",
    "meshsize": "Mesh size",
    "scaling": "Scaling",
    "ExitFullScreen": "Exit full screen",
    "text": "Text",
    "QRcode": "QR code",
    "barcode": "Barcode",
    "DMcode": "DM code",
    "pixelsize": "Pixel size",
    "Duringfilming": "Recording",
    "Multiplefileupload": "Batch upload",
    "fileupload": "File upload",
    "serialNumber": "Serial number",
    "unqualifiedCleaning": "Unqualified cleaning",
    "uploadPhotos": "Image upload",
    "earlyEnd": "End",
    "finish": "Finish",
    "qualified": "Qualified",
    "fallbackAll": "Withdraw All",
    "operatingParameters": "Running parameters",
    "pleaseScanTheQualityInspector": "Please scan the inspector",
    "cleaningTime": "Cleaning time",
    "selectDateTime": "Select time",
    "inspectionMethod": "Inspection method",
    "unqualifiedQuantity": "Unqualified quantity",
    "descriptiveText": "Description",
    "HandoverSupplyRoom": "CSSD handover",
    "continue": "Continue",
    "sterilizationQualityInspection": "Sterilization quality inspection",
    "randomInspectionOfSterilizationQuality": "Spot check of Sterilization Quality",
    "unqualified": "Unqualified",
    "sterilizationStartDate": "Sterilizing start date",
    "monitoringStartDate": "Monitoring start date",
    "monitoringEndDate": "monitoring End Date",
    "earlyReleaseStatus": "Pre-release status",
    "biologicalMonitoringResults": "Biological monitoring results",
    "reasonForEarlyRelease": "Reason of pre-release",
    "earlyReleaseTime": "Pre-release time",
    "earlyReleaseOfPedestrians": "Pre-release operator",
    "advanceReleasePackageNotificationTime": "Pre-release notification time",
    "selectDate": "Select date",
    "notifyTheExecutor": "Notify operator",
    "notificationDepartment": "Notify department",
    "released": "Released",
    "saveEdit": "Save",
    "pleaseScan": "Please scan",
    "first1": "First",
    "reasonForNonconformity": "Reason of unqualified",
    "submit": "Submit",
    "returnTo": "Withdraw to",
    "checkedBy": "Inspector",
    "placementLayer": "Placement layer:",
    "placementPosition": "Placement position",
    "placementMethod": "Placement method",
    "spotCheckResults": "Spot check result",
    "Totalbeforedisassembly": "Total quantity before disassembly",
    "Totalafterdisassembly": "Total quantity after disassembly",
    "Recyclingremarks": "Returning remarks",
    "Specialremarks": "Special remarks",
    "Totaldevices": "Total instrument",
    "Totalconsumables": "Total consumables",
    "bindingdetails": "binding details",
    "CancelScan": "Cancel scaning",
    "VideoPreview": "Preview",
    "Successfullyidentified": "Successfully identified",
    "Pieceequipment": "Piece instrument",
    "Pieceexcessequipment": "pieces redundant instrument, please confirm",
    "Registrationdevices": "Loaner registration",
    "Receivinginformation": "Receiving details",
    "Patientinformation": "Patient information",
    "Patientname": "Patient name",
    "surgicaldepartment": "Surgical department",
    "Affiliatedhospitalarea": "Affiliated campus",
    "DateOperation": "Surgery date",
    "Surgicalname": "Surgiry name",
    "deviceinformation": "Loaner details",
    "taglist": "Label list",
    "Bundlelabels": "Bundled labels",
    "Batchcode": "Batch ID",
    "Supplementarysorting": "Label Reprinting Sorting",
    "Totalcodeprinting": "Batch ID printing",
    "Supplementaryprinting": "Reprint set details",
    "Labelmodification": "Edit label",
    "sterilizationtime": "Sterilization time",
    "perioddays": "Validity(Day)",
    "Packager": "Packer",
    "Matchingperson": "Assembler",
    "Sterilizer": "Sterilizing operator",
    "supplementaryprinting": "Reason of reprint",
    "makesomeone": "Operator",
    "Bundlelabelcode": "Bundle label ID",
    "DeleteArchive": "Delete archives",
    "consumptionagency": "Internal outsourcing",
    "OutsourcedAgency": "External outsourcing",
    "Deliverer": "Deliveryman",
    "HideFilterItems": "Hide filters",
    "ShowFilterItems": "Show filters",
    "Recyclingdepartmentcategory": "Returning department category",
    "Classes": "Set type",
    "DirectCost": "Direct costing",
    "Cleaningqualitytime": "Cleaning inspection time",
    "Othercourtyarditems": "Sets from other campus",
    "SelectPrintAll": "Select and print all",
    "Selectcombinations": "Select and assemble all",
    "BatchPrintList": "Batch print list",
    "Printbasketlist": "Print tray list",
    "StagingList": "Temporarily saved list",
    "DressingPackageView": "Display linen sets",
    "Completionassembly": "Assembly completed",
    "PrintRecord": "Printed labels",
    "Documentprinting": "Print documents",
    "printlist": "Print list",
    "releasedInAdvance": "Released in advance",
    "notReleasedInAdvance": "Not released",
    "unregisteredResults": "Unrecorded",
    "kilogram": "kilogram",
    "endOfSterilization": "End sterilization",
    "toBePackaged": "To be packed",
    "spotCheckTime": "Spot check time",
    "documentProperties": "Document attribute",
    "packageProperties": "Sets property",
    "handleImmediately": "Proceed",
    "talkLater": "Later",
    "unplannedDistribution": "Unscheduled Delivery",
    "scanCode": "Scan item code",
    "inputCode": "Input item code",
    "addToPlanList": "Add to the schedule",
    "distributionAndPreservation": "Save delivery",
    "distributionRecords": "Delivery record",
    "mergePrinting": "Collective printing",
    "distributionStatisticsPrinting": "Print delivery summary",
    "printed": "Printed",
    "departmentType": "Department category",
    "toBeDistributed": "To be issued",
    "scannedCode": "Scanned",
    "actualRecycling": "Actual returned",
    "recyclingBatchCode": "Return batch ID",
    "distributionApplication": "Delivery application",
    "auditTime": "Approval time",
    "auditOrderCode": "Approval document ID",
    "issuanceOfReviewOrderCode": "Approved delivery ID",
    "loanApplication": "Borrowing application",
    "contain": "Include",
    "justCheck": "Search only",
    "packagingBatch": "Packing batch",
    "packagingTime": "Packing time",
    "packaginBgatchCode": "Packing batch ID",
    "packageType": "Set type",
    "engraveACard": "Tray label",
    "eliminate": "Exclude",
    "exchange": "Exchange sets",
    "automaticWarehouseInspection": "Automatically Delivery",
    "distributionCompleted": "Delivered",
    "removePackageCode": "Delete set code",
    "cancelDistribution": "Cancel delivery",
    "packageName": "Set name",
    "singleCode": "Document ID",
    "operationFailed": "Operation failure",
    "urgentLevel": "Urgent level",
    "deliveredBy": "Receiver",
    "confirmDistribution": "Confirm delivery",
    "Devicestatistics": "Instrument report",
    "packagestatistics": "Instrument set report",
    "Personnelstatistics": "Operator report",
    "Consumablestatistics": "Consumables report",
    "Equipmentstatistics": "Equipment report",
    "DepartmentStatistics": "Department report",
    "Supplierstatistics": "Supplier report",
    "Completedrecyclingapplication": "Return by application form",
    "ExpiredPackage": "Expired set",
    "ModifyUrgentLevel": "Edit urgent level",
    "Recyclingstatistics": "Return report",
    "backforeigninstruments": "Rewash Loaner",
    "Firstdevice": "Initial receiving Loaner",
    "ItemSummaryExport": "Export sets summary",
    "Cleaningresults": "Cleaning result",
    "Belongingdepartment": "Owner",
    "Totalcleaningamount": "Cleaning total",
    "departmentPackageCount": "Department set quantity",
    "inventoryWarning": "Inventory warning",
    "returningInventory": "Withdraw",
    "itemOutbound": "Sets delivery",
    "unqualifiedRegistration": "Record unqualified log",
    "confirmOutbound": "Confirm delivery",
    "confirmRegistration": "Confirm use",
    "sterileWarehouseReturn": "Sterile storage room withdraw",
    "addToDistributionList": "Add to delivery list",
    "operator": "Operator",
    "packageEncoding": "Set code",
    "warehousingTime": "Receiving time",
    "expirationTime": "Expiration time",
    "problemRegistration": "Log issues",
    "inventoryQuantity": "Stock quantity",
    "Cleaningprocess": "Cleaning process",
    "timeon": "Start time",
    "EndTime": "End time",
    "Sterilizationresults": "Sterilization result",
    "Sterilizationremarks": "Sterilization remarks",
    "Totalsterilizationcount": "Total sterilizing quantity",
    "EquipmentOperationRecordForm": "Equipment operating records",
    "Distributiondepartment": "Delivery department",
    "Distributionmethod": "Delivery method",
    "Stockreturn": "Withdraw",
    "Distributionstatistics": "Delivery report",
    "Sterilizationtype": "Sterilizing method",
    "Packagingtype": "Packing type",
    "Itemrecall": "Sets recall",
    "doesnotcontain": "exclude",
    "AmountExport": "Export amount",
    "Distributionstatisticsexport": "Export delivery record",
    "DepartmentAmountExport": "Export amount by department",
    "Totalnumberdevices": "Total number of instrument",
    "Totalamount": "Total amount",
    "Instrumentpackagetraceability": "Instrument set tracking",
    "Itemcode": "Set code",
    "Sterilizationbatchcode": "Sterilization batch ID",
    "Classnumber": "Batch ID",
    "Biologicalmonitoringpersonnel": "Biological monitor",
    "Receptiontime": "Receiving time",
    "Operatingtablenumber": "OR table ID",
    "Usagetime": "Usage time",
    "Useregistrant": "Patient REG operator",
    "monthlyreport": "Monthly report",
    "annualreport": "Yearly report",
    "month": "Month",
    "Includingdevices": "Contain Loaner",
    "Onlysearchdevicesnth": "Loaner only",
    "nosearchdevices": "Loaner excluded",
    "year": "Year",
    "Summarizeddepartment": "Summary by department",
    "SummarizePackageName": "Summary by set name",
    "Outsideplan": "Unplanned",
    "insideplan": "Planned",
    "Redemptionpackage": "Exchange sets",
    "Costanalysisstatistics": "Cost analysis report",
    "January": "January",
    "February": "February",
    "March": "March",
    "April": "April",
    "May": "May",
    "June": "June",
    "July": "July",
    "August": "August",
    "September": "September",
    "October": "October",
    "November": "November",
    "December": "December",
    "ManualCleaning": "Manual cleaning",
    "receiveRecord": "Receiving record",
    "sterileWarehouse": "Sterilization storage room",
    "totalReceived": "Total received amount",
    "onTheSameDay": "Today",
    "detailFolding": "Fold",
    "expandDetails": "Expand details",
    "receivingDetails": "Receiving details",
    "scanCodeReception": "Receiving by scanning",
    "storageLocation": "Storage location",
    "wetPackageRegistration": "Record wet pack",
    "auditAcceptance": "Receive approval",
    "receiveAll": "Receive all",
    "summaryView": "Summary",
    "errorLog": "Error log",
    "labelCode": "Label code",
    "receivingMethod": "Receiving method",
    "supplyRoomReception": "CSSD receiving",
    "confirmReceipt": "Receiving confirmation",
    "theCurrentInventoryIs": "Current storage is",
    "difference": "Variance",
    "scanErrorLog": "Error log of scanning",
    "scanCodeInputCorrection": "Correction on scan",
    "receivedSuccessfully": "Receive successfully",
    "questiontype": "Problem category",
    "location": "Position",
    "Sterilizationmodification": "Edit sterilization",
    "Secondinspector": "Second inspector",
    "anypointtime": "Anytime",
    "sterilizationtemperature": "Sterilization temperature",
    "Sterilizationpressure": "Sterilization pressure",
    "Mainloaditems": "Main loading sets",
    "chemicalmonitoring": "Chemistry monitor",
    "Printingrecordssterilization": "Sterilization process print records",
    "Shielddressingbag": "Hide linen sets",
    "Shielddevices": "Loaner hidden",
    "Totalnumberrooms": "Quantity in CSSD",
    "Totalnumberdepartments": "Quantity in department",
    "EngravedCodeDetails": "Sets detail",
    "PackageLocation": "Set location",
    "Locationengravingpackage": "Sets location",
    "Locationengravingpackagecode": "Sets location ID",
    "Engravedcode": "Sets code",
    "TagCode": "Label code",
    "TagCoCarvingPackageNamede": "Sets name",
    "Useregistrationstartdate": "Patient REG Start date",
    "Useregistrationenddate": "Patient REG End date",
    "Startdaterecyclingapplication": "Return request(start)",
    "Enddaterecyclingapplication": "Return request(end)",
    "Actualrecyclingstartdate": "Actual return(start)",
    "Actualrecyclingenddate": "Actual return(end)",
    "Recyclingtimeoutpackets": "Return expired sets",
    "Recyclingtimeoutpacketreminder": "Warning on expired sets",
    "Workarea": "Working area",
    "decontaminationarea": "Decontamination area",
    "Packagingarea": "Packing area",
    "sterile": "Sterile area",
    "JobDetails": "Working details",
    "reportingperiod": "Report frequency",
    "Reportstatisticalcaliber": "Report dimension",
    "DepartmentRelations": "Department property",
    "Statisticalmethods": "Calculation mode",
    "Flowstatistics": "Workflow report",
    "Unqualifiedinspection": "Uninspection",
    "Sterilizationstatistics": "Sterilization report",
    "Cleaningstatistics": "Cleaning report",
    "Bypackage": "By sets",
    "Bynumbertimes": "By time",
    "Hidesecondaryrecycling": "Hide recollection",
    "Nameforeigndevicemanufacturer": "Loaner name",
    "fuzzymatching": "Fuzzy match",
    "piece": "Piece",
    "Recyclingcompleted": "Returned",
    "Sterilizationcompleted": "Sterilized",
    "Packagingcompleted": "Packed",
    "Cleaningcompleted": "Cleaned",
    "patientAge": "Patient age",
    "patientGender": "Patient gender",
    "surgicalTime": "Surgery time",
    "cacheInformation": "Cache information",
    "queryPatientRecords": "Search patient records",
    "operatingRoomItems": "OR sets",
    "packagingReview": "Packing approval",
    "sterilizationAudit": "Sterilization approval",
    "unit": "Unit",
    "dateOfBirth": "Birth date",
    "patientDepartment": "Patient department",
    "patientBedNumber": "Patient bed number",
    "anesthesiaSystemName": "Anesthesia system name",
    "preface": "Operation serial No.",
    "operationDoctor": "Operating doctor",
    "doctorID": "Doctor's number",
    "heavyDrugResistance": "Heavy drug resistance",
    "batchReturnOfInventory": "Bulk return",
    "assignment": "Transfer",
    "patientCode": "Patient ID",
    "before": "before",
    "diagnosis": "diagnosis",
    "Sterilizationpotcode": "Load ID",
    "Potproperties": "Sterilizing type",
    "BDtesting": "BD test",
    "Leaktesting": "leaking test",
    "Physicalmonitoring": "physics monitor",
    "Totalnumberbatches": "Total batch quantity",
    "Totaloperatingexpenses": "Total processing amount",
    "Totalcostconsumption": "Additional cost of total disinfection",
    "order": "Time",
    "Nonsinglepot": "Collective sterilizing",
    "Emptypot": "Empty sterilizing",
    "Sterilizationworkload": "Sterilization workload",
    "Displaysupplyroomdata": "Display CSSD data",
    "Displaysterilizationqualifieddata": "Display qualified sterilization only",
    "Cleaningworkload": "Cleaning workload",
    "Displayonlyqualifiecleaningdata": "Display qualified cleaning data",
    "Cleaningpackageworkload": "Cleaning workload",
    "Distributionvolume": "Delivery workload",
    "Earlyreleasestatistics": "Release inadvance report",
    "Packagingworkload": "Packing workload",
    "PackageClassName": "Set type name",
    "Statisticsreturnissues": "Withdrawal report",
    "Reasonproblem": "Root cause",
    "Usagepackagecount": "Used sets report",
    "Statisticsnumberdevicesused": "Used instrument report",
    "applicationTemplate": "Application template",
    "applyForANewDeviceKit": "Apply new sets",
    "usingDirtyBags": "Use soiled sets",
    "borrowingRecords": "Borrowed record",
    "whetherRoReturnThePackage": "Returning",
    "applicant": "Applicant",
    "applicationRecord": "Application record",
    "blockIrrelevantItems": "Hide irrelevant sets",
    "inconsistentRecyclingApplication": "Application and returned QTY are inconsistent",
    "recyclingQuantity": "Return quantity",
    "reasonForRejection": "Reason of rejection",
    "revoke": "Cancel",
    "increaseQuantity": "Increase quantity",
    "borrowingTime": "Borrowing time",
    "borrower": "Lessee",
    "handWashingPeople": "Manual cleaning",
    "successfullyStaged": "Temporarily stored",
    "successfullySubmitted": "Submitted",
    "recyclingApplicationRecord": "Returning application record",
    "usageType": "Usage category",
    "patientName": "Patient name",
    "selfUseRecords": "Internal consumption record",
    "expiredEntries": "Expired record",
    "patientRecords": "Patient record",
    "Allocatedcostaccounting": "Cost allocation accounting",
    "CostItemSetting": "Cost item setting",
    "costitem": "Cost item",
    "DefaultCost": "Default cost($)",
    "open": "Open",
    "Foundationcoefficient": "Basic coefficient",
    "count": "Calculate",
    "Disinfectionbagcategory": "Instrument set category",
    "completedpackages": "Completed quantity (piece)",
    "Convertbasicworkload": "Convert to basic workload",
    "Disinfectionadditionalcosts": "Additional cost of disinfection ($/pc)",
    "Costconsumables": "Cost of consumables ($/pc)",
    "Depreciationpackaging": "Depreciation cost of packaging ($/pc)",
    "Pricingdisinfectionpackages": "Cost of various items($/piece)",
    "Incomedisinfectionpackagepricing": "Income of reprocessing($)",
    "CostRunchart": "Cost trend chart",
    "Totalmonthlydisinfectionpackageaudit": "Monthly total income($)",
    "Totalmonthlytotalcost": "Monthly total cost ($)",
    "Totalmonthlydisinfection": "Monthly total income($)",
    "disinfectionpackageconsumables": "Cost rate of consumables",
    "consumableApplication": "Consumables request",
    "isBorrowBagOrNot": "Borrowing sets",
    "applicationDate": "Application date",
    "issuedQuantity": "Deliveryed quantity",
    "ageUnit": "Age",
    "cancelRecordQuery": "Display cancellation",
    "recordExport": "Export record",
    "exportTotalItems": "Export subtotal",
    "cancelUse": "Usage cancellation",
    "preoperative": "Preoperation",
    "postoperative": "Postoperation",
    "preoperativeRegistration": "Preoperation record",
    "postoperativeRegistration": "Postoperation record",
    "postoperativePreservation": "Postoperation save",
    "canceledSuccessfully": "Cancelled",
    "cancelRecord": "Cancellation record",
    "pleaseSelectADate": "Please select a date",
    "Converttoequipment": "Convert into instrument",
    "Converttoconsumables": "Convert to Consumables",
    "departmentFilter": "Filter department",
    "scanCodeStatus": "Scanned status",
    "shieldOtherScanCodePack": "Hide sets scanned by others",
    "onselfScanCode": "My scanned sets",
    "targetState": "Compliance status",
    "scanNoQualified": "Scanning incompleted",
    "scanQualified": "Scanning completed",
    "noScan": "Unscanned",
    "scanCollectStatistics": "Scanned result overview",
    "inspectionType": "Inspection Type",
    "timeOfOccurrence": "Occurence time",
    "monitoringMethod": "Monitoring method",
    "unqualifiedType": "Unqualified type",
    "deviceName1": "Instruments Name",
    "deviceType": "Instruments Type",
    "inspector": "Inspector",
    "initialInspector": "First inspector",
    "reviewedBy": "Second inspector",
    "scheduling": "Scheduling",
    "workingHours": "Work time",
    "teamLeaderRandomInspection": "Spot check by leader ",
    "nurseSpotCheck": "Spot check by nurse",
    "qualityController": "Quality controller",
    "qualityInspectionParty": "Inspector",
    "whole": "Overall",
    "packOptionUnquality": "Packing materials unqualified",
    "packSignUnquality": "Packing sign unqualified",
    "packComplete": "Packing integrality",
    "discoverer": "Finder",
    "wetPackageTypes": "Wet pack category",
    "reasonForSteriAndSteam": "Sterilizer and steam reason",
    "loadCapcity": "Loading capacity",
    "loadPlaceMethod": "Placement method",
    "packElastic": "Packing tightness",
    "coolTime": "Cooling time",
    "minute": "Minutes ",
    "coolPlacePos": "Cooling position",
    "furnace": "Stove",
    "foundPlace": "Scene",
    "Programselectionerror": "Incorrect program",
    "Sterilizationfailure": "Unqualified sterilization",
    "Unqualifiedsterilizationloading": "Unqualified sterilization loading",
    "DeviceType": "Equipment type",
    "goodsAccept": "Sets receiving",
    "unqualifiedBatch": "Unqualified batch",
    "packUnqualified": "Unqualified packing",
    "SupRegistration": "Record missed item",
    "issueUnqualified": "Unqualified delivery",
    "wetPackage": "Wet pack",
    "packRegisterMsg1": "Record unqualified packing",
    "second": "Seconds ",
    "hour": "Hours ",
    "continuation": "Keep",
    "workloadStatistic": "Workload Report",
    "beforeCenter": "from CSSD",
    "afterCenter": "to CSSD",
    "statusNode": "Process node",
    "handleCenterMsg": "The page apply to at least two CSSDs",
    "handOverConfig": "Automatic handover",
    "elementSize": "Element size",
    "elementPos": "Element position",
    "saveFirst": "Please save first",
    "handleCenterMsg2": "One of the former or the latter supply rooms must be the current supply room",
    "applicationRecordBatchMsg": "There are different batches in the current application record that will be modified together. Do you want to continue",
    "newItemRecall": "New recall",
    "recallInitiationDate": "Recall initiate date ",
    "sterilizationFailureReportPerson": "Reporter",
    "recallStartDate": "Recall start date",
    "resultReviewer": "Approver",
    "recallCompletionDate": "Recall complete date",
    "recallDeadline": "Recall end date",
    "sterilizationBatchCode": "Sterile batch No.",
    "undistributedList": "Undelivered list",
    "issuedUnusedList": "Delivered but unused list",
    "issuedAndUsedList": "Delivered and used list",
    "recalledList": "Recalled list",
    "sterilizationQuery": "Sterile query",
    "nonConformanceReporter": "Reporter",
    "notRecalled": "Not recalled",
    "used": "Used",
    "recallSuccessful": "Successful recall",
    "packageHasUsedByPatient": "This set has been recorded with a patient",
    "packageSuccessfullyRecalled": "This set has been recalled successfully",
    "packageNotList": "This set isn't in the list",
    "batchReassembly": "Batch reassemble",
    "patientSurgicalName": "Operation name",
    "recallResults": "Recall result",
    "reassembleAll": "Totally reassemble",
    "patientInfoRegistra": "Patient registration",
    "pleaseSelectPackageReassembled": "Please selete the set to be reassembled",
    "planningArrangements": "Plan arrangement",
    "taskArrangement": "Task arrangement",
    "taskType": "Task category",
    "maintenanceInspectionType": "Maintain inspection type",
    "maintenanceManufacturer": "Maintain manufacturer",
    "faultOccurrenceTime": "Time of failure",
    "reasonDescription": "Reason",
    "newTask": "New",
    "editTask": "Edit",
    "planType": "Plan Type",
    "newPlan": "New",
    "editPlan": "Edit",
    "deletePlan": "Delete",
    "viewPlan": "Display",
    "viewTaskRecords": "Task records",
    "nameSupplyRoom": "CSSD name",
    "cyclePeriod": "Cycle time",
    "numberCycles": "Cycle index",
    "taskRecord": "Task records",
    "printAll": "Print all",
    "notStarted": "Unstarted",
    "start": "Start",
    "completed": "Completed",
    "regularInspections": "Regular inspection",
    "singlePlan": "Single plan",
    "isSureDelete": "Confirm to delete",
    "notPrintableTasks": "There are no printable tasks",
    "taskStartTime": "Task start time",
    "maintenanceRecords": "Maintenance records",
    "cancelTask": "Cancel",
    "planNumber": "Plan ID",
    "taskNumber": "Task ID",
    "faultTime": "Time of failure",
    "maintenanceTime": "Time of maintenance",
    "recordMaintenanceResults": "Maintenance result",
    "sterilizerName": "Sterilizer",
    "viewTotalSterilizationItems": "Sterilized utensils subtotal",
    "viewSterilizationItems": "Display sterilized utensils",
    "itemsInsideTheSterilizationRack": "Utensils of sterilize rack",
    "heatNumber": "Sterilize batch",
    "decontaminationKitTotalNumber": "Total number of sterilized sets",
    "decontaminationTotalCost": "Total amount of sterilization",
    "dataDictionary": "Data dictionary",
    "numericalValue": "Value",
    "isCustom": "Customizable",
    "isDefaultSelected": "Selected by default",
    "temperature": "Temperature",
    "PSSterilizer": "Please select a sterilize operator",
    "Additionelimination": "Additional sterilization",
    "TendencyChart": "Tendency Chart",
    "OutDepartmentCost": "Department cost",
    "DisinfectionSetCosts": "Disinfection set costs",
    "notPackageSterilizationBatch": "This set isn't in this batch",
    "Backwashingamount": "Cost of back washing",
    "referredtoas": "Short name",
    "website": "Website",
    "businesslicense": "Business license",
    "businessterm": "Business term",
    "Temporarybidding": "Temporary call for bids",
    "CompanyAddress": "Company address",
    "Shortcannotbeempty": "Short name can't be blank",
    "Categorycannotbeempty": "Category can't be blank",
    "Temporarybiddingcannotbeempty": "Temporary call for bids can't be blank",
    "Devicecode": "Instrument ID",
    "specifics": "Details",
    "RegistrationDepartment": "REG department",
    "Usingsurgicaldepartment": "REG OR",
    "admissionnumber": "Admission number",
    "registrationstatus": "REG status",
    "Batchreturn": "Batch return",
    "Batchlogout": "Batch write off",
    "logoff": "Write off",
    "unregistered": "Unregistrated",
    "registered": "Registrated",
    "Pleaseselectrecord": "Please select a record",
    "Patientsurgicalinformation": "Patient and surgery information",
    "ReturnInformation": "Return information",
    "Manufacturerhandoverpersonnel": "Handover staff of supplier",
    "Operatingroompersonnel": "OR staff",
    "Supplyroompersonnel": "CSSD staff",
    "Handovertime": "Handover time",
    "currentpersonnelnotsupplyroom": "Current user isn't from CSSD",
    "Batchcontinuation": "Batch keep",
    "Continueddevices": "Keep loaner",
    "Plannedsurgery": "Planned surgery",
    "PatientWard": "Patient ward",
    "ExportOverview": "Export summary",
    "ExportDetails": "Export details",
    "bulkedit": "Batch edit",
    "Exportdevicestatistics": "Export loaner summary",
    "devicestatistics": "Loaner summary",
    "Cleaningbatch": "Cleaning batch",
    "Reviewedby": "Reviewer",
    "Secondaryrecycler": "Secondary returner",
    "Secondaryrecoverytime": "Secondary return time",
    "Secondbackwashtime": "Secondary cleaning time",
    "Secondarybackwashingequipment": "Secondary cleaning device",
    "Secondarybackwashprocedure": "Secondary cleaning program",
    "Secondarybackwashbatch": "Secondary cleaning batch",
    "Secondarybackwashperson": "Secondary cleaning person",
    "Secondarybackwashresults": "Secondary cleaning result",
    "Cancellationtime": "Write off time",
    "Cancelledby": "Write off person",
    "Cancellationhandoverperson": "Write off handover person",
    "Returnedby": "Return person",
    "Returnhandoverperson": "Return handover person",
    "Returningphotos": " Photo ",
    "LogoutInformation": "Write off information",
    "EditingPatientInformation": "Edit patient information",
    "Totalnumberexternaldevices": "Loaner number",
    "Quantityrecycledafterexpiration": "Number after expired",
    "Numbernormalbackwashing": "Secondary cleaning quantity",
    "Numberothercancellationreasons": "Write off reason quantity",
    "Quantitybackwashed": "Secondary cleaning quantity",
    "Undistributedquantity": "Undelivered QTY",
    "Pleaseselecdeviceedited": "Please send loaner to be edit",
    "Borrowingreturningrecords": "Borrow and Return record",
    "Totalnumberimplantpackages": "Implant pack quantity",
    "Totalnumberimplantedobjects": "Implant quantity",
    "MenuID": "Menu ID",
    "ParentMenu": "Parent menu",
    "MenuName": "Menu name",
    "MenuRouting": "Maenu Routing",
    "Menuicon": "Menu icon",
    "Menuimage": "Menu picture",
    "Menuorder": "Menu order",
    "Whetherbutton": "Whether button",
    "DoesPDAdisplay": "Display on PDA",
    "Isanexternalchain": "External link",
    "editMenu": "Edit Menu",
    "DoesthePCdisplay": "PC menu",
    "Modifyexpirationremindertime": "Edit epxiration alert time",
    "Selfpackageoutboundregistration": "CSSD pack outbound registration",
    "Expiredpackageoutboundregistration": "Expired pack outbound registration",
    "RecallInformation": "Recall information",
    "PacketCountQuery": "Pack quantity query",
    "Allocateoperatingrooms": "Allocate OR room",
    "Returningoperatingroom": "Returned by OR",
    "Selfusepackageoutboundrecord": "CSSD pack outbound record",
    "ExpiredPackageDeliveryRecord": "Expired outbound record",
    "Allocateoperatingroomrecords": "Allocate OR room record",
    "Surgicalroomreturnrecord": "OR return record",
    "Transferrecordoperatingroom": "OR transfer record",
    "Deliverydate": "Outbound date",
    "primary": "Original",
    "Patientregistrationnot": "If patient registration",
    "EnterthetagcodepressEnter": "Enter after input Label CODE",
    "Remindertimesterilewarehouseexpirationdate": "Alert time for Stock expiration date",
    "Surgicalroomoutboundregistration": "OR outbound registration",
    "Stockreturnregistration": "Stock return registration",
    "Willnotjoinagain": "For those pack already allocate to OR room which will not be allocated again",
    "Pleaseregisteroutboundperson": "Please register outbound operate",
    "realtimeprocessing": "Please notice recall information",
    "Confirmstockreturn": "Confirm return to stock?",
    "departmentcodeselected": "Can not chooose corrent department code",
    "additionalCharge": "Additional fee",
    "remark": "Remark",
    "Packagingstatistics": "Pack statistics",
    "mappingAssociation": "Mapping Association",
    "deleteMap": "Delete Mapping",
    "patientsArticles": "Patient goods",
    "selectionPatients": "Select Patient",
    "periodhours": "Actual validity hour",
    "Assignedby": "Assigned by",
    "deletedstate": "Deleted status",
    "Notdeleted": "Undeleted",
    "yesDeleted": "Deleted",
    "Devicedetailscannobeempty": "Instrument details can't be blank",
    "SpecialRemarkcannobeempty": "Special remakrs can't be blank",
    "showPassword": "Show Password",
    "recycleInforMation": "Return Information",
    "recycleRemark": "Returen Memo",
    "syncCA": "Sync CA",
    "toChoose": "To be selected",
    "functionConfig": "configuration",
    "and": "and",
    "equal": "equal to",
    "greaterAndEqual": "greater than or equal to",
    "lessAndEqual": "less than or equal",
    "fixedValue": "Fixed value",
    "Othercourtyard": "Other campus",
    "CSSDhandover": "CSSD handover",
    "CSSDhandoverItems": "CSSD handover product",
    "Applicationsamount": "Amount",
    "Actualacceptanceamount": "Actual approved amount",
    "ProcessInterruption": "Process discontinued",
    "ProcessInterruptionMsg": "Selected sets cannot be packed due to process interruption, continue?",
    "carrier": "Carrier",
    "registrationuseagain": "The life cycle of this set has been reached, no return required",
    "download": "Download",
    "noPage": "This page cannot be accessed or doesn't exist",
    "reassemble": "Reassembly",
    "printTime": "Printing Time",
    "labelTemplateName": "Label Template",
    "packagMaterialName": "Packing Material",
    "printedBy": "Printer",
    "supplementaryPrintDetails": "Reprint Details",
    "numberLabelsPrinted": "Printed Quantity",
    "exportData": "Export Chart",
    "numberPrinInstPacks": "Print Set Quantity",
    "workloadStaff": "Workload",
    "reguPrinQuan": "1st Print Quantity",
    "quanSuppPrin": "Reprint Quantity",
    "PSLPR": "Proportion of Reprinting",
    "CDLPQ": "Daily Printing Trend",
    "areRequired": " are mandatory",
    "tagDesignPreview": "Label Preview",
    "tagTemplate": "Label Template",
    "templateSize": "Template Size",
    "tagInfo": "Label Information",
    "saveAsTemplate": "Save",
    "templateAlreadyExist": "Current template already has content, overwrite it?",
    "selectSizeFirst": "Please configure a label size first.",
    "printTag": "Print",
    "yearMonthDay": "Year/Month/Day",
    "hourMinuteSecond": "Hour/Minute/Second",
    "tagShowText": "Text to be shown",
    "sterilizeDeadline": "Expiration Date",
    "province": "State/Province",
    "city": "City",
    "district": "District",
    "county": "Area",
    "dealerName": "Dealer Name",
    "dealerRank": "Dealer Level",
    "dealerLeader": "Upper Level Dealer",
    "contactName": "Contact Name",
    "contactPhone": "Mobile",
    "tenantName": "Tenant Name",
    "userName": "User Name",
    "userAccount": "User Account",
    "loginPwd": "Login Password",
    "confirmPwd": "Confirm Password",
    "assignTenant": "Assign Tenant",
    "assignDepartment": "Assign Department",
    "identity": "Identity",
    "manageUser": "Administrator",
    "generalUser": "General User",
    "frozen": "Inactive",
    "authorizeMethod": "Authorization Method",
    "tagNumbers": "Label Quantity",
    "addressNotEmpty": "Address information is required",
    "timeNotEmpty": "Time information is required",
    "confirmPwdNotEmpty": "Confirm password is required",
    "mobileNotEmpty": "Phone number is required",
    "tenantNotEmpty": "Tenant is required",
    "homePage": "Home Page",
    "basicData": "Master Data",
    "sendToTenant": "Notice tenant",
    "changeTenant": "Switch tenant",
    "printWarning": "Label printing quota will be consumed, proceed it?",
    "confirmToDisable": "Confirm to inactive?",
    "cannotPrintByDelete": "The template is inactive, failed to print!",
    "downloadApp": "Download APP",
    "printerNumber": "Printer ID",
    "notActive": "Inactive",
    "activated": "Actived",
    "tenant": "Tanent",
    "activationTime": "Actived Time",
    "preateNewPrinter": "New",
    "batchResetTenants": "Reset Tenant Massively",
    "summaryStatistics": "Summary",
    "modifyingPrinter": "Edit",
    "resetTenant": "Reset Tenant",
    "validityDeadline": "Valid To",
    "manufacturer": "Manufacturer",
    "prinNumCannEmpt": "Printer ID is required",
    "bluetoothAddress": "Bluetooth Address",
    "bluetAddrCannEmpty": "Bluetooth address is required",
    "machinSerNumber": "Printer S/N",
    "seriNumCannEmpt": "Printer S/N is required",
    "activaStati": "Activation Summary",
    "byTenant": "By Tenant",
    "activationDate": "Actived Date",
    "encodePrinter": "By Printer ID",
    "datePrinCodeCreation": "Printer ID Creation Date",
    "mainExpiDate": "Warranty Expiration Date",
    "pleaEnteShipArea": "Please input delivery area",
    "pleaEnteValiBlueAddr": "Please input valid bluetooth address",
    "onlyPritActiStatRese": "Reset printer data is only available for activated printer",
    "areSureResetTenant": "Confirm to Reset Tenant",
    "resetSuccessful": "Reset Done",
    "onlyPrinDataInacStatDele": "Delete printer data is only available for inactive printer",
    "isSureDele": "Confirm to delete",
    "onlyInacDataModi": "Edit is only available for inactive data.",
    "verifTenants": "Relevant Tenant",
    "VerifTime": "Consumption Time",
    "codeValue": "Label S/N",
    "batchVoid": "Obsolete Massively",
    "batchWithdWriteOffs": "Withdrawal Consumption Massively",
    "writeStati": "Consumption Summary",
    "modifyQRCode": "Edit QR Code",
    "void": "Obsolete",
    "withVeri": "Withdrawal Consumption",
    "numberQRCodes": "QR Code QTY",
    "positiveDeviation": "Positive Tolerance",
    "verifDate": "Consumption Date",
    "sheet": "Piece",
    "writeOffUsers": "Operator",
    "QRCodePreview": "QR Code Preview",
    "pleaEnteNumQR": "Please input QR code QTY",
    "pleaEnteNumAbel": "Please input label QTY",
    "unprinted": "Unprinted",
    "verified": "Consumed",
    "printSuccessful": "Printed Successfully",
    "veriInvaDataCannInva": "Cannot obsolete consumed or obsoleted data",
    "isBatcVoidSeleData": "Confirm to obsolete selected data massively",
    "isVoidData": "Confirm to obsolete this data",
    "invalidSuccessfully": "Obsoleted Done",
    "onlyBatchWithdDataWrit": "Only consumed data can be withdrawn massively",
    "isBatcRetureSeleData": "Confirm to withdraw all selected  data",
    "isRetureSeleData": "Confirm to withdraw the consumption",
    "onlyRetureSeleData": "Only consumed data can be withdrawn",
    "withVeriSucc": "Consumption withdrawal successfully",
    "veriInvDataCanotDele": "Cannot delete consumed or obsoleted data",
    "isDeleSeleData": "Confirm to delete all seleted data",
    "isDeleData": "Confirm to delete this data",
    "enterUserName": "Please enter username",
    "enterPwd": "Please enter password",
    "selectCenter": "Please select the processing center",
    "selectDep": "Please select department",
    "aboutProduct": "Product Introduction",
    "systemManage": "System Mgt.",
    "scanAndDownload": "Scan to download (Android only)",
    "downloadPrinterDriver": "Download Printer Driver",
    "faqs": "User Guide",
    "activePrinter": "Activate Printer",
    "useCode": "Redeem",
    "updateLog": "Update Log",
    "activeTip": "Please scan the printer code and input the last four digits of the printer S/N",
    "printerCode": "Printer ID",
    "enterSerialCode": "Please enter the last four digits of the printer S/N",
    "plaseScanQr": "Please scan the label QR code",
    "qrCode": "QR Code",
    "userCenter": "My",
    "name": "Name",
    "phoneNumber": "Mobile",
    "tenantExpire": "Tenant Validity Period",
    "tenantAvailableTags": "Number of labels available for printing (Piece)",
    "tenantAvailablePrinters": "租户可用打印机数量（台）",
    "tenantOutDatedPrinters": "Number of non-warranty printers",
    "useTagRecord": "Record of consumed labels",
    "activePrinterRecord": "Record of activating printers",
    "oldPwd": "Old Password",
    "inputOldPwd": "Please enter old password",
    "newPwd": "New Password",
    "inputNewPwd": "Please input new password",
    "pleaseConfirmPwd": "Please confirm the new password",
    "printerFiles": "Printer files",
    "pleaseScanPrinterCode": "Please scan printer ID",
    "pleaseInputSerialCode": "Please enter the last four digits of the printer S/N",
    "activePrinterSuccessfully": "Printer has been activated",
    "hospitalSize": "Hospital Scale",
    "hospitalDepCount": "Department QTY",
    "packageDealCountByDay": "Daily Instrument Set QTY",
    "tagsPrintByDay": "Daily Label QTY",
    "hospitalSizeCannotBeNull": "Hospital scale is required",
    "hospitalDepCountCannotBeNull": "Department quantity is required",
    "packageDealCountByDayCannotBeNull": "Daily Instrument Set quantity is required",
    "tagsPrintByDayCannotBeNull": "Daily label quantity is required",
    "announceBySMS": "SMS Notification",
    "confirmToSendSMS": "Confirm to send the SMS",
    "jobPosition": "Title",
    "warehouseUser": "Warehouse User",
    "pleaseSelectTenant": "Please select a tenant",
    "pleaseSelectDataToDel": "Please select the data to be deleted",
    "pleaseSaveAndThenOperate": "Please proceed after saving",
    "expirePerDay": "Monthly Validity Period",
    "validatyHour": "Validity Hours",
    "validatyDay": "Validity Days",
    "pleaseSelectValidatyPeriodToSelect": "Please select a validity to be edit",
    "pleaseSelectDeviceStatus": "Please select a device status",
    "pleaseSelectSteriMethod": "Please select a sterilization method",
    "pleaseSelectBioFrequency": "Please select a frequency of BI-monitoring",
    "greating": "Hi!",
    "welcome": "Welcome to Honjo CLUE",
    "backToHome": "Home Page",
    "loginByApp": "Login APP",
    "guideDoc": "User Guide",
    "contractDealer": "Contact Dealer",
    "buyFromDealer": "Direct Purchase",
    "guideVideo": "Demo Video",
    "printerUseVideo": "Printer Installation Video",
    "SH": "Shanghai",
    "honjoMed": "Shanghai Honjo Information Technology Co., Ltd.",
    "honjoAddress": "Room 1701, No. 1188 North Qinzhou Road, Shanghai, China.",
    "honjoTel": "+86 4008938068",
    "changeBrowserAndRetry": "Please open the current link with your built-in browser and try again.",
    "checking": "Checking...",
    "onShelf": "Active",
    "offShelf": "Inactive",
    "locationIsRequired": "Missing location information",
    "swiperTitle": "Carousel Title",
    "showLoc": "Display Location",
    "linkAddress": "Redirect Address",
    "uploadSizeRequire": "To ensure the display effect on mobile devices, please choose images that are 500 x 265 or scaled proportionally.",
    "setPublishTime": "Scheduled Release Time",
    "publish": "Publish",
    "titleCannotBeNull": "Title cannot be blank",
    "locCannotBeNull": "Location cannot be blank",
    "orderCannotBeNull": "Sorting cannot be blank",
    "imgCannotBeNull": "Image cannot be blank",
    "publishTimeCannotBeNull": "Publish time cannot be blank",
    "announceContent": "Announcement Content",
    "timeRange": "Interval",
    "modifyAnnounce": "Edit Announcement",
    "sureToPublishAnnounce": "Confirm to publish the notice?",
    "publishSuccessfully": "Published successfully!",
    "sureToDelAnnounce": "Confirm to cancel the notice?",
    "offShelfSuccessfully": "Successful!",
    "announcePublishTimeRange": "Announcement release time range",
    "whetherToPublish": "Publish or not",
    "startTimeCannotBeEarlyThanNow": "The start time cannot be earlier than the current time",
    "pleaseInputAnnounceContent": "Please input the announcement content",
    "pleaseSelectTime": "Please select a time",
    "createAnnounce": "New",
    "notPublished": "Unpublished",
    "publishing": "Publishing",
    "publishStopped": "Publishing stopped",
    "publishCompleted": "Publishing completed",
    "universalUse": "General",
    "publishedMaintaining": "Release maintenance",
    "publishedVersion": "Release version",
    "updatedLogTitle": "Update Log Title",
    "createUpdateLog": "New",
    "modifyLog": "Modify Log",
    "readLog": "Display Log",
    "publishTime": "Release Time",
    "updateLogContent": "Updated Log",
    "publishedDataCannotBeDelete": "Data that has been published cannot be deleted",
    "allTenantCount": "Total Number of Tenants",
    "userCount": "Number of Users",
    "tenantActivedCount": "Activated Printer Number (Tenant)",
    "innerPrinterActivedCount": "Activated Printer Number (Internal)",
    "statisticTitle1": "Statistics by Tenant - Label printing",
    "statisticTitle2": "Daily Trend of Total prints",
    "statisticTitle3": "Tenant Geographical Distribution Chart",
    "statisticUnit1": "Unit",
    "tenantType": "Tenant Type",
    "tenantSize": "Tenant Size",
    "tenantSizeStatistic": "Tenant Scale (Average Daily Reprocessing)",
    "totalTagCount": "Total Number of Labels",
    "addTag": "Add Label",
    "publicTagInfo": "Shared Information",
    "uniqueTagInfo": "Individual Information",
    "printCount": "Printing Quantity",
    "pleaseSelectTagTemplate": "Please select a label template first",
    "processNumber": "Processing ID",
    "tagIdentifyCode": "Label Identification Code",
    "typeString": "Character",
    "typeCode128": "Barcode",
    "typeDatamatrix": "DM Code",
    "actualSize": "Actual Size",
    "exportChart": "Export chart",
    "printingPlatform": "Printing Device",
    "printOnMobile": "Mobile Printing",
    "printOnPC": "PC Printing",
    "deviationNumber": "Positive Deviation Quantity",
    "deviationValidateMsg": "Please enter a number not exceeding 10",
    "printDate": "Printing Date",
    "generateChart": "Generate Chart",
    "totalCount": "Total Cost ($)",
    "byOutDepartment": "By Distribution Department",
    "to": "~",
    "summaryByDepartmentCost": "Department Cost Summary",
    "byInstrumentset": "By Instrument Set",
    "summaryByInstrumentsetCost": "Cost Summary by Instrument Set",
    "noOutDepartment": "Missing Distrubution Department",
    "cleaningvehicle": "Cleaning Cart",
    "notcleanedsimultaneously": "Cleaning carts, utensils, and basket instruments cannot be cleaned simultaneously.",
    "qualifyUserMsg": "Please register personnel with sterilization qualifications.",
    "qualifyUserMsg2": "The second quality inspector cannot be the same as the first.",
    "programAstrict": "Program restrictions",
    "staging": "Workstation",
    "Currenttotalreceived": "Current total pending reception",
    "distributedsameday": "Total issued on the same day",
    "ExpandAll": "Expand all",
    "collapseall": "Collapse all",
    "Rejectionoperation": "Reject operation",
    "IsUsed": "Is it used?",
    "IsCancelled": "Is it canceled?",
    "isReturned": "Is it returned?",
    "cancelCause": "Cancellation reason",
    "receiversMinNumMsg": "The minimum number of counters is",
    "BatchModify": "Batch modification",
    "Cleaningrecordmodification": "Cleaning record modification",
    "processPacketCount": "Package count in process",
    "Interruptornot": "Is it interrupted?",
    "recordingtime": "Record time",
    "Collectionrecord": "Collection record",
    "CollectionDepartment": "Collection department",
    "sterilizationProgramMsg": "Individual packages cannot start with the current sterilization procedure as set, continue?",
    "sterilizationProgramMsg2": "Individual packages cannot start with the current sterilization procedure as set.",
    "SummaryPackageQuantity": "Total package summary",
    "Distributioncode": "Distribution code",
    "Onlyredemptionpackage": "Only check exchange packages",
    "Handwashprinting": "Hand wash printing",
    "Machinewashprinting": "Machine wash printing",
    "DiscoveryPrescription": "Discovering department",
    "qualityPrescription": "Quality inspection department",
    "cleanedNumber": "Total number of cleanings",
    "qualifiedNumber": "Total number of qualified items",
    "unqualifiedNumber": "Total number of unqualified items",
    "qualifiedRate": "Qualification rate",
    "PotItem": "Same pot items",
    "firstCheckUid": "Please scan the first quality inspector",
    "secondCheckUid": "Please scan the second quality inspector",
    "packagenotfilteringcriteria": "The Set is not in the filter conditions",
    "Aresuretoreceiveall": "Confirm all received?",
    "Aresurereview": "Confirm audit reception?",
    "ReceiveTimeoutAlert": "Reception timeout reminder",
    "Choosingreturnedsterilization": "Selecting the sterilizer re-shelves, not selecting returns to pending sterilization",
    "reshelf": "Re-shelf",
    "instrumentPackageMsg": "Packaging method and processing method cannot be empty",
    "instrumentPackageMsg2": "The supply room's packages will not be automatically issued, the value has been changed to -1",
    "OnlyRelevantPack": "Only check related instrument packages",
    "ManufacturersContactWay": "Manufacturer's contact information",
    "checkHasRecycledByCodesMsg1": "The package code has been recycled, continue?",
    "checkHasRecycledByCodesMsg2": "The package code has been recycled and cannot be applied again",
    "Oneclickreception": "One-click receive",
    "selectSurgeryInfo": "Please select surgery information",
    "Synchronizeapplicationamount": "Synchronize application amount",
    "wantupdateapplicationpackage": "Update the new application fee for this package?",
    "theme": "Theme",
    "sterilestorageMsg": "The package is not in the sterilization quality inspection list",
    "procedureErrorPlaceholder": "Press enter after inputting the pot number",
    "Allreturnstoinventory": "Return all to the warehouse",
    "packagereturnTwo": "There are packages with existing department acceptance records, return the package?",
    "Recyclingregistrant": "Recycling registrar",
    "Repackaging": "Repackage",
    "Aresurerepackageit": "Confirm repacking?",
    "Cleaningreview": "Cleaning review",
    "wanttocontinue": "The deleted package has a department application for recycling records, re-recycling is required, continue?",
    "participationPack": "Participate in packaging",
    "packType": "First inspection",
    "packageType2": "Second inspection",
    "checkType": "Third inspection",
    "belongdepartment": "The affiliated department cannot be empty",
    "packInList": "The package is already in the list",
    "SurgicalNumber": "Surgery order number",
    "version": "Iterative version",
    "display": "Display content",
    "processConfiguration": "Process configuration",
    "divtConfiguration": "Dictionary configuration",
    "processConfigurationName": "Process configuration name",
    "configurationRemark": "Configuration description",
    "processConfigurationID": "Process configuration ID value",
    "divtConfigurationName": "Dictionary configuration name",
    "divtConfigurationType": "Dictionary configuration Type value",
    "newIssue": "New distribution reconstruction version",
    "scanCodeMode": "Scanning mode",
    "ConfigurationValue": "Configuration value",
    "typeValue": "Type value",
    "pageDisplay": "Page display",
    "GeneralSerrings": "General settings",
    "PrintAbout": "Printing related",
    "ScheduledExpirationReminder": "Plan expiration reminder",
    "Otherinformation": "Other information",
    "Departmentaltransfertime": "Transfer to department time",
    "Departuretransfertime": "Transfer from department time",
    "Departmentalorderprinting": "Departmental order printing",
    "Dateandtimeempty": "Date and time cannot be empty",
    "Recyclingpackagecode": "Recycling package code",
    "defaultUrgent": "Default urgent",
    "noUrgent": "Not urgent",
    "Packaginginquirylabel": "Packaging query label",
    "Statisticalcycle": "Statistical cycle",
    "Statisticalprocess": "Statistical process",
    "Statisticalcalculation": "Statistical calculation",
    "Unitpriceamount": "Unit price amount",
    "Carvingcodepackage": "Engraved code package",
    "Byengravingcode": "By engraved code",
    "Bypackagename": "By package name",
    "Bynumberofpackages": "By package quantity",
    "statisticalsummary": "Statistical summary",
    "Bypackagecategory": "By package category",
    "Bypackageclassname": "By package class name",
    "Accordingtopackagespecifications": "By package specifications",
    "Bypackagetype": "By package type",
    "Groupbypackage": "By package group",
    "Byinstrumentpackagename": "By instrument package name",
    "Bydepartment": "By department",
    "Pleaseselectthesummarytype": "Please select statistical summary",
    "Exportsuccessful": "Export successful",
    "Jumptoqueryfiles": "Jump to query file",
    "cancelLog": "Cancel distribution log",
    "Inventorysheetprinting": "Inventory list printing",
    "operationTime": "Operation time",
    "operateComputer": "Operating computer",
    "Biologicalpackageprinting": "Biological monitoring package printing",
    "BDpackageprinting": "BD monitoring package printing",
    "vesselNumberMsg": "Please fill in the number of utensils",
    "packagingTimeRequired": "Please fill in the packaging time",
    "clearingRemind": "Some packages have a contradiction between the recycling time and the current cleaning time, the recycling time needs to be modified before they can be supplemented.",
    "outerNameSelect": "Please select the verified package name",
    "hiddenInventory": "Hide inventory number 0",
    "Sterilizerperson": "Sterilizer",
    "Feedepartment": "Charging department",
    "expiringdate": "Expiration date",
    "PatientRegistration": "Patient registration",
    "minCostamount": "Minimum unit cost amount",
    "packageSummary": "Package type summary",
    "releaseSummary": "Distribution classification summary",
    "equipmentOperation": "Equipment operation",
    "washingVessel": "Cleaning utensils",
    "highLevelWorkload": "High-level workload",
    "Tobeassembled": "Pending assembly",
    "PrintInformation": "Printing information",
    "sterilizationManyPack": "Shelves 0 packages",
    "sterilizationManyPackMsg": "The list currently has no packages that can be shelved",
    "existingdepartment": "Please select an existing department",
    "itemdetailsbeempty": "Item details cannot be empty",
    "msg2Issue": "Sterile warehouse has",
    "msg3Issue": "Packages expired,",
    "msg4Issue": "Packages are about to expire,",
    "msg5Issue": "Handle immediately?",
    "Equipmentnumber": "Equipment number",
    "Unusedquantity": "Unused quantity",
    "sterilizationManyPackMsg2": "0 packages were shelved this time, please confirm.",
    "PrintSettings": "Printing settings",
    "Packagingtotalcode": "Total packaging code",
    "packagePrintMsg": "The package is an engraved package but lacks engraved code information, please delete and recycle again",
    "Unqualifiedcleaningandreturn": "Return due to unqualified cleaning",
    "Unqualifiedsterilizationandreturn": "Return due to unqualified sterilization",
    "Packagingreturn": "Packaging return",
    "Notequalto": "Not equal to",
    "Empty": "Is empty",
    "Notempty": "Is not empty",
    "Basicinformationsupplement": "Basic information (supplement)",
    "Selectatleastonetimerange": "Select at least one time range",
    "tardive": "Late delivery",
    "Unregisteredpatients": "Unregistered patients",
    "isContinuation": "Is it continued?",
    "renewCode": "Continue package code",
    "Shortesttime": "Shortest time",
    "Maximumtime": "Longest time",
    "Maximumtimenotempty": "Longest time cannot be empty",
    "Shortesttimenotempty": "Shortest time cannot be empty",
    "sterilizingRack": "On sterilization rack",
    "InMachineSterilization": "Sterilization in machine",
    "ChangeSterilizer": "Change sterilizer",
    "MonitorPackagePrinting": "Monitoring package printing",
    "soldOut": "Off the shelf",
    "sterilizationMsg": "Please select the sterilization rack",
    "ChangeShelf": "Change sterilization rack",
    "sterilizationMsg2": "Please select the package to be off the shelf",
    "putaway": "On the shelf",
    "inEquipment": "Enter the machine",
    "sterilizationMsg3": "Please configure the sterilization rack",
    "ScanTheShelf": "Scan and shelf",
    "ScanOffTheShelf": "Scan and off the shelf",
    "sterilizationMsg4": "Please select the sterilizer or sterilization rack",
    "sterilizationMsg5": "Please configure the sterilizer",
    "BatchMonitoringPrint": "Batch monitoring package printing",
    "allShelfDelete": "Remove entire rack",
    "setTotalCount": "Total packages",
    "DeviceSystemCode": "Equipment system coding",
    "IsBindingSterilizer": "Is it bound to the sterilization rack?",
    "BindingSterilizer": "Bind sterilization rack",
    "Newequipmentpackageoutbound": "New instrument package outbound",
    "Createanewoutboundtask": "New outbound task",
    "Outboundtype": "Outbound type",
    "Numbernewpackages": "New instrument package quantity",
    "Requestforoutboundquantity": "Apply for outbound quantity",
    "ProgramRemarks": "Program notes",
    "sterilizationMsg6": "Please scan the selected sterilizer's program code",
    "Newpackage": "New package",
    "Theoperatingroomcannotbeempty": "Operating room cannot be empty",
    "ConsumerSchool": "Hospital supply school",
    "OfficeAsepticLibrary": "Departmental sterile warehouse",
    "scrutineer": "Checker",
    "RecyclingComparison": "Recovery usage comparison",
    "Addcustomfields": "Add custom fields",
    "CustomFieldName": "Custom field name",
    "CustomFieldValues": "Custom field value",
    "GXYDrRgistrationMsg": "Patient names are inconsistent, cannot be saved, please modify",
    "SterilizationQualityUser": "Sterilization quality inspector",
    "scanSterilizationQualityUser": "Please scan the sterilization quality inspector",
    "questiontypeGroup": "Problem group",
    "Summaryprinting": "Summary printing",
    "checkEquipment": "Equipment inspection",
    "backWashingRate": "Counter-washing rate",
    "outDatedInstrumentsetsCannotBeAssigned": "Expired packages cannot be assigned to operating rooms",
    "Viewphotos": "View images",
    "cleanStartTime": "Start time of cleaning",
    "exportDetail": "Detail export",
    "infectedInstrumentSetCount": "Total number of infected instrument packages",
    "infectedInstrumentCount": "Total number of infected instruments",
    "Nopicturesavailable": "No images displayed",
    "DepartmentAggregationExport": "Departmental aggregation export",
    "Exportconsumablesdetails": "Consumable detail export",
    "Pleaseselectthedistributiontime": "Please select the distribution time",
    "Totalnumberbasicdatainstruments": "Basic data instrument quantity total",
    "Totalnumberactualprocessinstruments": "Actual process instrument quantity total",
    "Externaldeviceprinting": "Foreign instrument printing",
    "warehouseMsg": "Instrument packages cannot be selected in batches, please register instrument packages individually",
    "equipmentMsg": "Data that cannot be printed",
    "Recyclingdepartmentgroup": "Recycling department group",
    "Batchoperations": "Batch operation",
    "totalCostedFee": "Total additional costs",
    "biologicalMonitoringDay": "Biological monitoring days",
    "biologicalMonitoringMsg": "More than x days without biological monitoring",
    "common": "Total",
    "Departmentcategory": "Department category",
    "Packagegrouping": "Package grouping",
    "addIntoPackaging": "Join packaging consumption",
    "Printseparately": "Print separately",
    "useDeadline": "Usage period",
    "notFilled": "Not filled",
    "haveExpired": "Expired",
    "committed": "Submitted",
    "Statisticaldimension": "Statistical dimension",
    "Statisticalsupplyroomequipmentpackage": "Statistical supply room instrument packages",
    "StatisticalDataSpecification": "Statistical data specification",
    "Basicdata": "Basic data",
    "Processdata": "Process data",
    "AddCancelModify": "Add consumption modification",
    "secondIssueRightMsg6": "The current list has more than 500 packages, please re-filter and then register the distribution of packages",
    "isCollection": "Default centralized procurement",
    "sterilizedShelvesNumber": "Current sterilization rack shelf quantity",
    "sterilizerMachinesNumber": "Current sterilizer machine quantity",
    "area": "Area",
    "handoverRegistration": "Shift registration",
    "Totalnumberofdevices": "Total number of instruments",
    "CleaningHistory": "Cleaning history records",
    "collation": "Check",
    "Cleaningmachineparameterverification": "Cleaning machine parameter check",
    "Verifytheresults": "Check results",
    "Verifier": "Checker",
    "spareBag": "Spare package",
    "operationScheduleTime": "Surgery scheduling time",
    "Urgentmodification": "Modify urgency",
    "Scanningtime": "Scanning time",
    "ReturnPackage": "Return package",
    "successIn": "Successfully added",
    "removbasketitem": "Remove the basket from this line of items?",
    "operationStorage": "Outbound instrument package reminder",
    "cancelReviewReject": "Cancel audit and reject",
    "recycleTrack": "Recycling inquiry",
    "reasonDeletion": "Please select the deletion reason",
    "selectreasonDeletion": "Please select the checker",
    "urgentReason": "Urgency reason",
    "withdraw": "Withdraw",
    "Batchrecycling": "Batch recycling",
    "Withdrawalsuccessful": "Withdrawal successful",
    "Recyclinginprogress": "Recycling in progress",
    "PatientID": "Patient ID",
    "warehouseMsg1": "Please select the outbound date and try to export again",
    "Cannotexpedite": "Cannot expedite",
    "Thispackageunableexpedited": "The package is set as non-urgent",
    "clearAllCost": "Total cleaning cost",
    "packAllCost": "Total packaging cost",
    "sterilizationAllCost": "Total sterilization cost",
    "issueAllCost": "Total distribution cost",
    "otherAllCost": "Total other costs",
    "totalIssue": "Total distribution",
    "totalCost": "Total cost",
    "synchronizingInformation": "Synchronize information",
    "ordernoMsg1": "Already registered, do not repeat the record",
    "ordernoMsg2": "The manufacturer, patient, and package information have been recorded, do you want to overwrite?",
    "Longqueueforcleaningmachines": "Long queue for the dragon cleaning machine",
    "Entrysequence": "Entry order",
    "Numberofbasketscleaned": "Number of cleaning baskets",
    "cacheList": "Temporary storage list",
    "containerCode": "Basket coding",
    "cancelStaging": "Cancel temporary storage",
    "isCancelStaging": "Cancel temporary storage?",
    "pleaseCancelStaging": "Please check the items to cancel temporary storage",
    "pleaseCancelStaging1": "Please check the items for temporary storage",
    "Settlementreport": "Settlement report",
    "Settlementresults": "Settlement result",
    "stagingCause": "Temporary storage reason",
    "Theregistrantcannotempty": "The registrar cannot be empty",
    "Theoperatingroomcannotempty": "The operating room cannot be empty",
    "DistributionDepartmentTeam": "Distribution department group",
    "cameraID": "Camera ID",
    "cameraLabel": "Camera name",
    "forFaceIdentificationLogin": "Face recognition login",
    "Lowtemperaturesterilizationcost": "Low temperature sterilization cost",
    "Lowtemperaturesterilizationcostcalculation": "Calculation of low-temperature sterilization cost",
    "Calculatesterilizationcost": "Calculate sterilization cost",
    "Wholepotsterilizationcost": "Whole pot sterilization cost (Yuan)",
    "faceIdentificationCameraNotExist": "The camera recorded for face recognition does not exist, please reset",
    "Costallocationaccountingsterilizationequipment": "Sterilization equipment apportioned cost accounting",
    "Facialdatabase": "Face library",
    "Activatefacialrecognition": "Activate face recognition",
    "Searchbydepartment": "Inquiry by department",
    "Searchbysterilizationbatchnumber": "Inquiry by sterilization batch number",
    "Sterilizationsharingtotalcost": "Total sterilization apportioned cost",
    "secondIssueRightMsg7": "There are incompletely distributed instrument packages in the sterile warehouse, jump to process?",
    "weightReason": "Weighing exception reason",
    "weightAbnormalMsg": "Weighing exception, please select the reason",
    "Selectprogramagain": "Sterilizer selected, please scan the selected program again",
    "Programselectionsuccessful": "Program selection successful",
    "sterilizationIssuedMsg": "This sterilization has been completed",
    "scanCodeCheck": "Scan and select",
    "scanCancellation": "Scan and cancel",
    "Samenamepackageaggregationsorting": "Aggregate and sort packages with the same name",
    "nonconformingPart": "Unqualified parts",
    "engravingRestoration": "Engraved code repair",
    "restoration": "Repair",
    "recycleMsg": "This will restore the package to a recyclable state, continue?",
    "vesselNumberMsg2": "Please select the utensils",
    "actualWeight": "Actual weight",
    "designWeight": "Designed weight",
    "checkedPack": "Selected",
    "classifier": "Classifier",
    "foreignInstrumentsUsed": "Commonly used foreign instruments",
    "qualitySupplementRegistration": "Quality control supplementary registration",
    "equipmentRegistration": "Equipment registration",
    "operatorSelection": "Please select the operator",
    "Surgerycompleted": "Surgery completed",
    "searchitemsbatch": "Query items recovered in the same batch?",
    "Usagesituation": "Usage",
    "transferredpatientrecordcontinue": "The package will be transferred to the current patient record, continue?",
    "endsurgery": "Confirm the end of surgery?",
    "Bydate": "By date",
    "uniLogin": "Single sign-on",
    "Maximumpackaginglimit": "Maximum number of packages limited",
    "Whetherregistration": "Is registration used",
    "Querywarehousedepartment": "Departmental sterile warehouse inquiry",
    "sterilizationStartTime": "Sterilization start time",
    "Pleaseuploadagain": "Please re-upload",
    "Packagingsplit": "Package splitting",
    "BatchSplitting": "Batch splitting",
    "instrumentPackageMsg3": "The process of this package will be terminated after splitting",
    "cleaningBagAssembly": "Clean package assembly",
    "packagePrintMsg2": "No packages to split",
    "cleaningInspector": "Cleaning quality checker",
    "sweepCoding": "Scan code",
    "Temperaturepressurenumber": "Thermometer and pressure gauge number",
    "Temperaturepressurerecord": "Thermometer and pressure gauge records",
    "questionContent": "Question content",
    "descriptionContent": "Description",
    "readed": "Read",
    "unRead": "Unread",
    "markAllAsReaded": "Mark all as read",
    "whetherMarkAllAsReaded": "Whether to mark all as read？",
    "china": 'China',
    "malaysia": "Malaysia",
    "country": "Country",
    "systemName": "Honjo CLUE",
    "tenantState": "Tenant status",
    "contractType": "Contract Type",
    "official": "Official",
    "trial": "Trial",
    "contractNumber": "Contract No.",
    "contractNumberFormatError": "Contract No. format is wrong",
    "contractNumberCannotBeNull": "Contract No. can not be blank",
    "userType": "User Type",
    "dealerUser": "Dealer User",
    "tenantUser": "Tenant User",
    "assignDealer": "Assign to Dealer",
    "emailAddress": "Email Address",
    "dealerNotEmpty": "Dealer can not be blank",
    "identityNotEmpty": "Identity can not be blank",
    "userTypeNotEmpty": "User Type can not be blank",
    "emailFormatError": "Please input right email format",
    "dataLableNotEmpty": "Dictionary label can not be blank",
    "dataKeyValueNotEmpty": "Data Key can not be blank",
    "displaySortingNotEmpty": "Sorting can not be blank",
    "divtNameNotEmpty": "Dictionary Name can not be blank",
  }
}